{
    "recruiting": "İşe alım",
    "base_title": "The Reflection",
    "base_title_ru": "SkillsTrainer",
    "404_title": "Sayfa Bulunamadı ⚠️",
    "404_description": "Aradığınız sayfayı bulamadık.",
    "404_home": "Ana Sayfaya Dön",
    "401_title": "Yetkiniz yok! 🔐",
    "401_description": "Bu sayfaya erişim izniniz yok. Ana sayfaya dönün!.",
    "401_home": "Ana Sayfaya Dön",
    "changes_saved": "Değişiklikler kaydedildi",
    "coming_soon": "Yakında",
    " ": " ",
    "select_date_and_time": "Tarih ve saat seçin",
    "select_date": "Tarih seçin",
    "chat": "Sohbet",
    "menu": "Menü",
    "games": "Oturumlar",
    "tours": "Turlar",
    "library": "Kütüphane",
    "library-video": "Video",
    "library-scorm": "Kurslar",
    "library-documents": "Belgeler",
    "knowledge-base": "Bilgi Bankası",
    "courses": "Kurslar",
    "courses-page": {
        "title": "Kurslar",
        "create": "Kurs oluştur",
        "edit": "Kursu düzenle",
        "empty": "Henüz kurs yok",
        "fields": {
            "title": "Başlık",
            "description": "Açıklama",
            "documents-count": "Belgeler"
        },
        "headers": {
            "title": "Başlık",
            "description": "Açıklama",
            "documents": "Belgeler",
            "actions": "İşlemler"
        },
        "dialog": {
            "title-label": "Başlık",
            "description-label": "Açıklama",
            "documents-label": "Belgeler",
            "documents-placeholder": "Bilgi tabanı belgelerini seçin",
            "save": "Kaydet",
            "cancel": "İptal"
        },
        "messages": {
            "created": "Kurs oluşturuldu",
            "updated": "Kurs güncellendi",
            "deleted": "Kurs silindi",
            "error": "Bir şeyler ters gitti"
        },
        "confirm-delete": "Bu kurs silinsin mi? Bu işlem geri alınamaz."
    },
    "ai-study-chat": "AI çalışma sohbeti",
    "ai-study-chat-page": {
        "title": "AI çalışma sohbeti",
        "new-conversation": "Yeni konuşma",
        "empty-sidebar": "Henüz konuşma yok",
        "empty-thread": "Öğrenmeye başlamak için bir kurs veya senaryo seçin",
        "untitled": "Yeni sohbet",
        "input-placeholder": "Sorunuzu yazın…",
        "send": "Gönder",
        "typing": "Asistan yazıyor…",
        "sources": "Kaynaklar ({count})",
        "sources-label": "Kaynaklar",
        "score": "ilgi düzeyi",
        "retry": "Yeniden dene",
        "copy": "Kopyala",
        "copied": "Kopyalandı",
        "failed": "Gönderilemedi",
        "search-placeholder": "Konuşmalarda ara",
        "search-empty": "Sonuç bulunamadı",
        "empty": {
            "heading": "Öğrenmenize yardımcı olmaya hazır",
            "subtitle": "Kurs materyalleri hakkında her şeyi sorun — cevabı bilgi tabanında bulup kaynakları göstereceğim."
        },
        "groups": {
            "today": "Bugün",
            "yesterday": "Dün",
            "earlier": "Daha önce"
        },
        "composer": {
            "context": "Bağlam:",
            "hint": "Yanıtlar materyallerinizden AI tarafından oluşturulur · Göndermek için Enter, yeni satır için Shift+Enter"
        },
        "quota": {
            "remaining": "{count} mesaj hakkınız kaldı",
            "exhausted": "AI sohbet mesaj hakkınız doldu.",
            "unavailable": "AI sohbet planınızda mevcut değil."
        },
        "new-dialog": {
            "title": "Yeni konuşma",
            "subtitle": "AI'nin yanıt vereceği kaynağı seçin",
            "source-type": "Kaynak",
            "source-course": "Kurs",
            "source-scenario": "Senaryo",
            "source-competency": "Yetkinlik",
            "pick-course": "Bir kurs seçin",
            "pick-scenario": "Bir senaryo seçin",
            "pick-competency": "Bir yetkinlik seçin",
            "pick-target": "Tüm oturumlar veya belirli bir oturum",
            "all-games": "Tüm oturumlar — ilerlemem",
            "all-games-sub": "Bu yetkinlik için puan eğilimleri",
            "back": "Geri",
            "no-games": "Tamamlanmış oturum yok",
            "empty-competencies": "Henüz tamamlanmış oturum yok",
            "empty-competencies-hint": "Bir yetkinliği olan bir senaryoda oturumu tamamlayın — AI değerlendirmeniz burada görünecek",
            "empty-courses": "Henüz mevcut kurs yok",
            "empty-scenarios": "Henüz mevcut senaryo yok",
            "tag-game": "Oturum",
            "search": "Ara…",
            "search-empty": "Sonuç bulunamadı",
            "start": "Başlat",
            "cancel": "İptal"
        },
        "stage": {
            "searching": "Materyalleriniz taranıyor…",
            "reading": "Kaynaklar okunuyor…",
            "writing": "Yanıt yazılıyor…",
            "writing_sources": "{count} pasaj analiz ediliyor…",
            "summarizing_short": "Önceki bağlam düzenleniyor",
            "searching_short": "Materyalleriniz taranıyor",
            "reading_short": "Kaynaklar okunuyor",
            "writing_short": "Yanıt yazılıyor",
            "writing_sources_short": "{count} pasaj analiz ediliyor"
        },
        "suggestions-fallback": [
            {
                "title": "Materyalleri özetle",
                "subtitle": "Ana noktalar"
            },
            {
                "title": "Bir çalışma planı oluştur",
                "subtitle": "Nereden başlamalı"
            },
            {
                "title": "Beni test et",
                "subtitle": "Hızlı kontrol"
            },
            {
                "title": "Basitçe açıkla",
                "subtitle": "Jargon olmadan"
            }
        ],
        "suggestions-fallback-debrief": [
            {
                "title": "Bu oturumu değerlendir",
                "subtitle": "Ana çıkarımlar"
            },
            {
                "title": "Neyi iyi yaptım?",
                "subtitle": "Güçlü yönlerim"
            },
            {
                "title": "Nerede ve neden hata yaptım?",
                "subtitle": "Gelişim noktaları"
            },
            {
                "title": "Bir sonraki oturumda neyi geliştirmeliyim?",
                "subtitle": "Somut adımlar"
            }
        ],
        "suggestions-fallback-progress": [
            {
                "title": "Sonuçlarım nasıl bir eğilim gösteriyor?",
                "subtitle": "Oturumlar genelinde"
            },
            {
                "title": "Güçlü ve zayıf becerilerim",
                "subtitle": "Oturum puanlarına göre"
            },
            {
                "title": "Neye odaklanmalıyım?",
                "subtitle": "Eğitim önceliği"
            },
            {
                "title": "İlk ve son oturumlarımı karşılaştır",
                "subtitle": "Neler gelişti"
            }
        ],
        "errors": {
            "send": "Mesajınız gönderilemedi. Lütfen tekrar deneyin.",
            "quota": "Mesaj kotası doldu.",
            "rate_limit": "Çok fazla istek. Lütfen bir dakika bekleyip tekrar deneyin.",
            "provider_unsupported": "Bilgi tabanı sohbeti, kuruluşunuzun mevcut AI sağlayıcısıyla kullanılamıyor.",
            "generic": "Bir şeyler ters gitti."
        }
    },
    "scenarios": "Senaryolar",
    "competencies": "Yetkinlikler",
    "competencies-list": "Liste",
    "skills": "Yetkinlikler",
    "home": "Ana Sayfa",
    "home_player": "Katılımcı",
    "player": "Katılımcı",
    "home_expert": "Uzman",
    "reports-analytics-tours": "Turlar",
    "reports": "Raporlar",
    "skill_reports": {
        "skill_development_report": "Beceri Gelişim Raporu",
        "generate": "Oluştur",
        "generate_description": "Seçilen dönem için kapsamlı bir beceri gelişim raporu oluşturun",
        "manager_description": "Kuruluşunuzdaki çalışanlar için beceri gelişim raporları oluşturun",
        "date": "Tarih",
        "competence": "Yetkinlik",
        "period": "Dönem",
        "status_label": "Durum",
        "actions": "İşlemler",
        "employee": "Çalışan",
        "view": "Raporu görüntüle",
        "download_pdf": "PDF indir",
        "no_reports": "Henüz oluşturulmuş rapor yok",
        "data_not_available": "Rapor verileri henüz mevcut değil",
        "generation_failed": "Rapor oluşturma başarısız oldu",
        "retry": "Yeniden dene",
        "rate_limit_exceeded": "Rapor oluşturma sınırına ulaşıldı. Lütfen daha sonra tekrar deneyin.",
        "too_many_pending": "Devam eden çok fazla rapor var. Lütfen tamamlanmalarını bekleyin.",
        "no_games_for_report": "Seçilen dönem ve yetkinlik için tamamlanmış oturum bulunamadı. Rapor oluşturulamıyor.",
        "report_already_exists": "Bu parametrelere sahip bir rapor zaten mevcut. Aşağıdaki listeyi kontrol edin.",
        "period_too_long": "Rapor dönemi bir yılı aşamaz.",
        "invalid_parameters": "Yetkinliği ve dönemi kontrol edin",
        "filter_by_employee": "Çalışana göre filtrele...",
        "batch": {
            "mode_single": "Tek rapor",
            "mode_batch": "Toplu",
            "load_employees": "Çalışanları göster",
            "sessions": "Oturum",
            "no_candidates": "Seçilen yetkinlik ve dönem için tamamlanmış oturumu olan çalışan yok",
            "generate_selected": "Oluştur ({count})",
            "selected_limit": "Bir seferde en fazla {max} çalışan seçebilirsiniz",
            "progress": "{total} rapordan {ready} tanesi hazır",
            "failed_count": "Hatalı: {count}",
            "status_unknown": "Durum bilinmiyor",
            "status_unknown_hint": "Rapor listede bulunamadı — aşağıdaki rapor tablosuna bakın",
            "reused": "Yeniden kullanılan rapor: {count} — son {hours} saat içinde oluşturulmuştu, yeniden üretilmedi",
            "reused_badge": "Yeniden kullanıldı",
            "reused_on": "{date} tarihinde oluşturuldu",
            "download_all": "Tümünü indir",
            "toggle_details": "Toplu işin içeriğini göster",
            "dismiss_confirm": "Bu toplu iş hâlâ oluşturuluyor. Ekrandan kaldırılsın mı? İlerleme ve “Tümünü indir” düğmesi kaybolur, raporlar aşağıdaki listede kalır.",
            "archive_unavailable": "Arşiv oluşturulamadı: bazı raporlar henüz hazır değil ya da artık kullanılamıyor",
            "archive_failed": "Arşiv indirilemedi",
            "archive_building": "Arşiv oluşturuluyor…",
            "archive_build_failed": "Arşiv oluşturulamadı. Lütfen tekrar deneyin.",
            "candidates_failed": "Çalışan listesi yüklenemedi",
            "stale_selection": "Seçilen çalışanların bir kısmı artık kullanılamıyor. Liste yenilendi — yeniden seçin."
        },
        "quota": {
            "remaining_hour": "Rapor sınırı: saatte {limit}. Şu anda {remaining} tane daha isteyebilirsiniz. Daha az çalışan seçin veya {time} saatinde tekrar deneyin.",
            "remaining_day": "Rapor sınırı: günde {limit}. Şu anda {remaining} tane daha isteyebilirsiniz. Daha az çalışan seçin veya {time} saatinde tekrar deneyin.",
            "exhausted_hour": "Rapor sınırına ulaşıldı (saatte {limit}). {time} saatinde sıfırlanacak.",
            "exhausted_day": "Rapor sınırına ulaşıldı (günde {limit}). {time} saatinde sıfırlanacak.",
            "too_large_hour": "Rapor sınırı: saatte {limit}. Daha az çalışan seçin.",
            "too_large_day": "Rapor sınırı: günde {limit}. Daha az çalışan seçin."
        },
        "status": {
            "pending": "Beklemede",
            "collecting_data": "Veriler toplanıyor...",
            "analyzing": "AI Analizi...",
            "generating_pdf": "PDF oluşturuluyor...",
            "ready": "Hazır",
            "failed": "Başarısız"
        },
        "report": {
            "kicker": "Yetkinlik Gelişim Raporu",
            "position": "Pozisyon",
            "department": "Departman",
            "period": "Dönem",
            "games_count": "Oynanan oturum sayısı",
            "not_specified_f": "Belirtilmemiş",
            "not_specified_n": "Belirtilmemiş",
            "fig": {
                "your_average": "Ortalama puanınız",
                "company_average": "Şirket ortalaması",
                "participants": "Dönemdeki katılımcı sayısı",
                "skills_count": "Değerlendirilen beceri sayısı"
            },
            "sec": {
                "profile": "Yetkinlik Profili",
                "trend": "Oturumlara Göre Seyir",
                "strengths": "Nelere Dayanabilirsiniz",
                "priorities": "Üç Gelişim Önceliği",
                "skills": "Beceri Bazında Analiz",
                "plan": "Üç Aylık Plan"
            },
            "legend": {
                "you": "Puanınız",
                "company": "Şirket ortalaması"
            },
            "dotplot_caption": "Ortalamadan sapma — en büyük üstünlükten en büyük geri kalışa",
            "trend_disclaimer": "Oturum puanları doğrudan karşılaştırılabilir değildir: vakaların zorluğu oturumdan oturuma değişir. Puanın düşmesi tek başına becerinin gerilediği anlamına gelmez; bu grafik bir gözlemdir, bir yargı değildir.",
            "no_comparison": "Şirket ortalamasıyla karşılaştırma yapılamıyor: bu dönemde bu yetkinlikte üçten az kişi oturum gerçekleştirdi. Rapor mutlak puanlar üzerine kuruludur.",
            "skill": {
                "works": "İyi giden yönler",
                "blocks": "Zorlayan yönler",
                "actions": "Ne yapmalı",
                "out_of_ten": "10'luk ölçekte",
                "company_short": "şirket"
            },
            "level": {
                "outstanding": "Üstün sonuç",
                "strength": "Güçlü yön",
                "meets_standard": "Şirket düzeyinde",
                "needs_attention": "Dikkat gerektiriyor",
                "needs_development": "Gelişim alanı"
            },
            "plan": {
                "month": "Ay",
                "goals": "Hedefler",
                "actions": "Eylemler"
            },
            "colophon": {
                "built_on": "Rapor {from} — {to} dönemindeki oturumlara dayanmaktadır. Toplam oturum sayısı: {count}.",
                "comparison": "Karşılaştırma, aynı döneme ait şirket ortalamasıyla yapılmıştır. Katılımcı sayısı: {count}."
            }
        }
    },
    "ranking": "Sıralama",
    "analytics": "Analitik",
    "support": "Destek",
    "users": "Kullanıcılar",
    "participants": "Katılımcılar",
    "departments": "Departmanlar",
    "positions": "Pozisyonlar",
    "user-custom-fields": "Özel Alanlar",
    "administration": "Yönetim",
    "ai-assistants": "AI Asistanları",
    "ai-prompts": "AI Prompt'ları",
    "evaluation-rubrics": "Değerlendirme Rubrikleri",
    "ai-profiles": "AI Profilleri",
    "ai-connectors": "AI Bağlayıcıları",
    "Audit logs": "Denetim kayıtları",
    "organizations": "Organizasyonlar",
    "loading": "Yükleniyor...",
    "retry": "Yeniden dene",
    "previous": "Önceki",
    "next": "Sonraki",
    "save": "Kaydet",
    "copy": "Kopyala",
    "copy_failed": "Otomatik olarak kopyalanamadı. Alandaki metni seçip elle kopyalayın (Ctrl+C veya ⌘C).",
    "confirm": "Onayla",
    "suggest": "Öner",
    "generate": "Oluştur",
    "cancel": "İptal",
    "close": "Kapat",
    "search": "Ara...",
    "accept": "Kabul et",
    "propose": "Öner",
    "decline": "Reddet",
    "send_request": "İstek gönder",
    "assign": "Ata",
    "actions": " ",
    "evaluators": {
        "ai": "AI",
        "expert": "Uzman",
        "player": "Katılımcı",
        "manager": "Yönetici",
        "head": "Ekip Lideri"
    },
    "statistics": {
        "date_from": "Başlangıç",
        "date_to": "Bitiş",
        "competence": "Yetkinlik",
        "evaluator": "Değerlendirici",
        "last_games_effectiveness": {
            "effectiveness": "Etkinlik",
            "title": "Etkinlik İlerlemesi"
        },
        "skill_trend": {
            "average_score": "Ortalama Puan",
            "game": "Oturum",
            "score": "Puan",
            "title": "Yetkinliklere Göre Ortalama Puan"
        },
        "player_competence_radar": {
            "title": "Beceri İstatistikleri",
            "top": "İlk 10",
            "players_in_company": "Şirketteki katılımcılar",
            "by_games": "Oturumlara göre analiz",
            "subtitle": "Şirket ortalamasıyla karşılaştırma",
            "filter": "Filtrele",
            "you": "Siz",
            "company": "Şirket",
            "average_score": "ortalama puan",
            "skills_counted": "{total} beceriden {counted} tanesine göre"
        },
        "personal_radar": {
            "title": "Yetkinlik Radarım",
            "subtitle": "Becerilerinizin kuruluş ortalamasıyla karşılaştırılması"
        },
        "skill_gap_heatmap": {
            "title": "Beceri Açığı Isı Haritası",
            "no_data": "Seçilen filtreler için değerlendirme verisi bulunmuyor"
        },
        "progress_over_time": {
            "title": "Zaman İçindeki İlerleme",
            "avg_score": "Ortalama Puan",
            "week": "Hafta",
            "month": "Ay",
            "no_data": "Seçilen dönem için veri yok"
        },
        "department_aggregation": {
            "title": "Departman Karşılaştırması",
            "avg_score": "Ortalama Puan",
            "players": "Katılımcılar",
            "no_data": "Seçilen filtreler için departman verisi bulunmuyor"
        },
        "employee_comparison": {
            "title": "Çalışan Karşılaştırması",
            "subtitle": "2-3 çalışanın beceri değerlendirmelerini yan yana karşılaştırın",
            "select_players": "Karşılaştırmak için 2-3 katılımcı seçin",
            "max_players": "En fazla 3 katılımcıya izin verilir"
        },
        "score_distribution": {
            "title": "Puan Dağılımı",
            "subtitle": "Yetkinlik veya beceriye göre değerlendirme puanlarının dağılımı",
            "count": "Değerlendirmeler",
            "q1": "Q1",
            "median": "Medyan",
            "q3": "Q3",
            "average": "Ortalama",
            "no_data": "Seçilen filtreler için değerlendirme verisi bulunmuyor"
        },
        "evaluator_consistency": {
            "title": "Değerlendirici Tutarlılığı",
            "subtitle": "Değerlendirici türleri arasındaki korelasyon ve ortalama puanlar",
            "correlation": "Korelasyon Matrisi",
            "correlation_method": "Pearson",
            "avg_by_type": "Değerlendirici Türüne Göre Ortalama",
            "pair_details": "Çift Detayları",
            "corr_label": "Kor.",
            "gap_label": "Fark",
            "shared_label": "Ortak",
            "no_data": "Tutarlılığı hesaplamak için yeterli değerlendirme verisi yok"
        },
        "engagement_dashboard": {
            "title": "Katılım Panosu",
            "subtitle": "Aktivite yoğunluğunu takip edin ve dikkat gerektiren çalışanları belirleyin",
            "active_employees": "Aktif Çalışanlar",
            "avg_games_week": "Ort. Oturum / Hafta",
            "inactive_employees": "Pasif Çalışanlar",
            "inactive_threshold_days": "Pasiflik eşiği (gün)",
            "days_inactive": "{days} gündür pasif",
            "last_game_date": "Son oturum: {date}",
            "no_games_yet": "Henüz oturum yok",
            "no_inactive": "Pasif çalışan bulunamadı"
        },
        "strengths_weaknesses": {
            "title": "Güçlü ve Zayıf Yönler",
            "subtitle": "En güçlü ve en zayıf 3 beceriniz",
            "strengths": "Güçlü Yönler",
            "weaknesses": "Geliştirilmesi Gereken Alanlar",
            "no_data": "Henüz yeterli değerlendirme verisi yok"
        },
        "peer_percentile": {
            "title": "Akran Yüzdelik Dilimi",
            "subtitle": "Kuruluşunuzdaki akranlarınıza göre beceri sıralamanız",
            "top_percent": "İlk %{percent}",
            "bottom_percent": "Son %{percent}",
            "no_data": "Yüzdelik dilimleri hesaplamak için yeterli akran verisi yok"
        },
        "evaluation_gap": {
            "title": "Öz Değerlendirme ve AI Değerlendirmesi Farkı",
            "subtitle": "Kör noktalarınızı keşfetmek için öz değerlendirmenizi AI değerlendirmesiyle karşılaştırın",
            "self_assessment": "Öz Değerlendirme",
            "ai_evaluation": "AI Değerlendirmesi",
            "gap": "Fark",
            "skill": "Beceri",
            "no_data": "Veri yok - hem öz değerlendirme hem de AI değerlendirmesi gereklidir"
        },
        "improvement_velocity": {
            "title": "Gelişim Hızı",
            "subtitle": "Son 30 gün ile önceki 30 gün arasındaki puan değişimi",
            "no_data": "Gelişimi hesaplamak için yeterli veri yok",
            "improved": "Gelişti",
            "declined": "Geriledi"
        },
        "activity_calendar": {
            "title": "Aktivite Takvimi",
            "subtitle": "Son 6 aydaki günlük oturum katılımı",
            "current_streak": "Mevcut Seri",
            "longest_streak": "En Uzun Seri",
            "total_games": "Toplam Oturum",
            "games_count": "{count} oturum",
            "no_activity": "Son 6 ayda kayıtlı aktivite yok"
        },
        "session_history": {
            "title": "Oturum Geçmişi",
            "subtitle": "Son oturumlarınız ve sonuçlarınız",
            "date": "Tarih",
            "scenario": "Senaryo",
            "type": "Tür",
            "score": "Puan",
            "status": "Durum",
            "types": {
                "player_vs_player": "Katılımcıya Karşı Katılımcı",
                "player_vs_ai": "Katılımcıya Karşı AI",
                "training": "Eğitim"
            },
            "statuses": {
                "time_scheduling": "Başlangıç zamanı planlama",
                "waiting_for_start": "Başlamayı bekliyor",
                "missed": "Kaçırıldı",
                "in_progress": "Devam ediyor",
                "protocol_approval": "Protokol onayı",
                "failed": "Başarısız",
                "completed": "Tamamlandı"
            }
        }
    },
    "org_activity": {
        "title": "Kuruluş Aktivitesi",
        "empty": "Bu dönemde aktivite yok",
        "search_placeholder": "Kuruluşlarda ara…",
        "chips": {
            "today": "Bugün",
            "week": "Hafta",
            "all": "Tümü",
            "inactive": "Pasif ≥7g"
        },
        "sort": {
            "recent": "En son",
            "least_active": "En az aktif",
            "az": "A–Z"
        },
        "card": {
            "plays_in_7_days": "7 günde {count} oyun",
            "open_menu": "Menüyü aç",
            "open_audit_log": "Denetim günlüğünü aç"
        },
        "drawer": {
            "title": "Son aktivite",
            "open_audit_log": "Tam denetim günlüğünü aç",
            "active_for": "{time} önce aktifti",
            "summary": "{games} oyun · {scenarios} senaryo · {ai_profiles} AI profili",
            "buckets": {
                "today": "Bugün",
                "yesterday": "Dün",
                "this_week": "Bu hafta",
                "older": "Daha eski"
            }
        },
        "events": {
            "game_created": "Oyun oynandı",
            "voice_session_created": "Sesli oturum başlatıldı",
            "scenario_created": "Senaryo oluşturuldu",
            "scenario_updated": "Senaryo güncellendi",
            "ai_profile_created": "AI profili oluşturuldu",
            "profile_created": "Yeni çalışan kaydedildi"
        }
    },
    "participant": {
        "upcoming_games": "Yaklaşan oturumlar",
        "for_rank_games": "Değerlendirilecek"
    },
    "roles": {
        "player": "Katılımcı",
        "admin": "SuperAdmin (sistem)",
        "scoped_admin": "Kıdemli Yönetici",
        "observer": "Gözlemci",
        "captain": "Kaptan",
        "expert": "Uzman",
        "lead_expert": "Kıdemli Uzman",
        "manager": "Yönetici",
        "support": "Destek",
        "early_access": "Erken erişim",
        "head": "Ekip Lideri",
        "candidate": "Aday"
    },
    "user-status": {
        "active": "Aktif",
        "inactive": "Pasif",
        "pending": "Beklemede"
    },
    "pagination": {
        "showing": "gösteriliyor",
        "to": "ile",
        "of": "/",
        "entries": "kayıt"
    },
    "validator": {
        "required": "Bu alan zorunludur",
        "library": "Dosya boyutu 500MB'den küçük olmalıdır",
        "email": "E-posta alanı geçerli bir e-posta olmalıdır",
        "password": "Alan en az bir büyük harf, küçük harf, özel karakter ve rakam içermeli, en az 8 karakter olmalıdır",
        "confirm": "Şifreyi Onayla alanı eşleşmiyor",
        "at_least": "Alan en az şunu içermelidir",
        "items": "öğe",
        "number": "Bu alan bir tam sayı olmalıdır",
        "is_odd": "Bu alan çift sayı olmalıdır",
        "number_between": "Şu aralıkta bir sayı girin",
        "number_and": "ve",
        "date_range_required": "Aralık zorunludur",
        "invalid_date_range": "Geçersiz aralık",
        "invalid_date_format": "Geçersiz tarih formatı",
        "start_date_after_end_date": "Başlangıç tarihi bitiş tarihinden önce olmalıdır",
        "max_180_days": "En fazla 180 gün"
    },
    "user": {
        "menu": {
            "settings": "Ayarlar",
            "statistics": "İstatistikler",
            "logout": "Çıkış yap"
        }
    },
    "theme": {
        "system": "Sistem",
        "light": "Açık",
        "dark": "Koyu"
    },
    "error": {
        "default": "Üzgünüz, bir hata oluştu. Uzmanlarımız durumdan haberdar ve sorunu en kısa sürede çözecekler.",
        "unauthorized": "Oturumunuzun süresi doldu.",
        "contact-support": "Üzgünüz, bir hata oluştu. Lütfen teknik destek ile iletişime geçin",
        "forbidden": "Erişim reddedildi"
    },
    "confirmation": {
        "sure": "Bu kaydı silmek istediğinizden emin misiniz?",
        "sure_return_to_time_scheduling": "Oturumu başlangıç zamanı belirleme aşamasına geri döndürmek istediğinizden emin misiniz?",
        "sure_restore": "Bu kaydı geri yüklemek istediğinizden emin misiniz?",
        "sure_mark_completed": "Bu oturumu tamamlandı olarak işaretlemek istediğinizden emin misiniz?",
        "sure_mark_failed": "Oyun başarısız olarak işaretlensin ve tüm değerlendirmeler ile katılımcı protokolleri kalıcı olarak silinsin mi?",
        "success": "Başarılı!",
        "deleted": "Silindi",
        "failed_marked": "Oyun başarısız olarak işaretlendi",
        "restored": "Geri yüklendi",
        "cancel": "İptal edildi",
        "yes": "Evet",
        "no": "Hayır"
    },
    "dashboards": {
        "player": {
            "summary": {
                "welcome": "Tekrar hoş geldiniz",
                "progress": "Genel ilerlemeniz",
                "stats": {
                    "minutes": "Oynanan dakika",
                    "effectiveness": "Genel puan",
                    "completed_games_count": "Tamamlanan oturumlar",
                    "total_games_count": "Toplam oturumlar"
                }
            },
            "cards": {
                "players_rating": {
                    "title": "Şirket sıralaması",
                    "player": "Katılımcı",
                    "effectiveness": "Etkinlik"
                }
            }
        },
        "head": {
            "my_stats": "İstatistiklerim",
            "subordinates": "Ekibim",
            "subordinate_stats": "Ekip üyesi istatistikleri",
            "select_subordinate": "İstatistiklerini görüntülemek için bir ekip üyesi seçin",
            "no_subordinates": "Atanmış ekip üyesi yok"
        }
    },
    "chat-page": {
        "last_game": "Son oturum",
        "chats": "Sohbetler",
        "no-chats": "Sohbet bulunamadı",
        "contacts": "Kişiler",
        "choose": "Kişi seç",
        "send": "Gönder",
        "type": "Mesajınızı yazın...",
        "no-contacts": "Kişi bulunamadı",
        "search": "Ara...",
        "start_conversation": "Sohbeti başlat",
        "start_connecting": " Soldaki kişilerden birini seçerek insanlarla bağlantı kurmaya başlayın"
    },
    "scenarios-page": {
        "title": "Başlık",
        "export-docx": ".docx olarak dışa aktar",
        "copy_title": "Senaryoyu kopyala",
        "generate_ai_title": "AI ile Senaryo Oluştur",
        "organization": "Şirket",
        "competence": "Yetkinlik",
        "actions": " ",
        "add": "Senaryo ekle",
        "ai-generate": "AI ile Oluştur",
        "copy": "Senaryoyu kopyala",
        "add_popup": "Senaryo ekle",
        "delete": "Senaryoyu sil",
        "edit": "Senaryoyu düzenle",
        "edit_popup": "Senaryoyu düzenle",
        "industries": [
            "FMCG/Perakende",
            "İlaç Sektörü",
            "Bankalar ve Fintech",
            "Otelcilik ve Turizm",
            "IT Şirketleri/SaaS",
            "Restoran İşletmeciliği/HoReCa",
            "E-ticaret/Pazaryerleri",
            "Üretim/Endüstri 4.0",
            "Lojistik ve T&L",
            "Telekomünikasyon",
            "Eğitim/EdTech",
            "Kimya Sektörü",
            "Tedarik Zinciri Yazılımı",
            "Kamu/Kâr Amacı Gütmeyen Kuruluşlar"
        ],
        "case_types": [
            "Liderlik ve İnsan Yönetimi",
            "İşe Alım ve Personel Değerlendirmesi",
            "Satış ve Müşteri Hizmetleri",
            "Müzakere ve Etkileme",
            "Çatışma Yönetimi",
            "Strateji ve Uygulama"
        ],
        "cases": [
            [
                "SMART/OKR Hedef Belirleme",
                "Gelişim Odaklı Geri Bildirim Verme (SBI/COIN)",
                "Yetki Devri",
                "GROW Koçluk Modeli",
                "Performans Değerlendirmesi",
                "Mentorluk"
            ],
            [
                "Yetkinlik Bazlı Mülakat (CBI)",
                "Değerlendirme/Değerlendirme Merkezi",
                "Oryantasyon Oturumu"
            ],
            [
                "Klasik Ürün/Hizmet Satışı",
                "İtirazları Karşılama",
                "Ek Satış/Çapraz Satış",
                "Şikayet Yönetimi",
                "Çok Kanallı Satış"
            ],
            [
                "Şirket İçi Bütçe/Kaynak Müzakereleri",
                "Müşteri/Tedarikçi Sözleşmesi",
                "Kriz Müzakereleri"
            ],
            [
                "Kişilerarası Ekip Çatışması",
                "Yönetici-Ast İlişkisi",
                "Değer/Etik Çatışması"
            ],
            [
                "Proje Portföyü Önceliklendirme",
                "Değişim Yönetimi",
                "Risk Analizi"
            ]
        ],
        "formats": [
            "1-1",
            "Takımlar"
        ],
        "labels": {
            "industry": "Sektör",
            "case_type": "Vaka Türü",
            "case": "Vaka",
            "format": "Format",
            "duration": "Süre (dakika)",
            "game_vs_ai": "AI'ye Karşı Oturum",
            "level": "Seviye",
            "competence": "Yetkinlik",
            "description": "Senaryo Açıklaması",
            "description_hint": "İsteğe bağlı olarak oluşturmak istediğiniz senaryoyu tanımlayın (en fazla 4000 karakter)"
        },
        "generating_in_progress": "Senaryo oluşturuluyor, lütfen bekleyin..."
    },
    "analytics-page": {
        "tours-page": {
            "tour": "Tur",
            "full_name": "Katılımcı",
            "games_count": "Oturumlar",
            "team": "Takım",
            "export": "Dışa aktar",
            "effectiveness": "Etkinlik"
        }
    },
    "report-filters": {
        "department": "Departman",
        "position": "Pozisyon",
        "employee": "Çalışan",
        "scenario": "Senaryo",
        "competence": "Yetkinlik",
        "period": "Dönem",
        "reset": "Sıfırla",
        "only-period-competence": "Yalnızca dönem ve yetkinlik filtreleri uygulanır"
    },
    "competencies-page": {
        "title": "Başlık",
        "export-docx": ".docx olarak dışa aktar",
        "skills": "Yetkinlikler",
        "text": "Metin",
        "display_order": "Sıralama",
        "ai-assistant": "AI Asistanı",
        "language": "Dil",
        "department": "Departman",
        "evaluation-format": "Değerlendirme formatı",
        "evaluation-format-skills": "Yetkinlik puanları",
        "evaluation-format-checklist": "İkili kontrol listesi",
        "rubric": "Rubrik",
        "evaluation-target": "Kimi değerlendiriyoruz?",
        "evaluation-both": "Her iki katılımcı",
        "evaluation-team-a": "Yalnızca A takımı",
        "evaluation-both-tooltip": "Her iki katılımcı da değerlendirilir - müzakere senaryoları için uygundur",
        "evaluation-team-a-tooltip": "Yalnızca lider değerlendirilir - geri bildirim formatı",
        "actions": " ",
        "add": "Yetkinlik ekle",
        "add_popup": "Yetkinlik ekle",
        "delete": "Yetkinliği sil",
        "edit": "Yetkinliği düzenle",
        "edit_popup": "Yetkinliği düzenle"
    },
    "faq-page": {
        "title": "Sorular",
        "question": "Soru",
        "text": "Cevap",
        "is_shared": "Tüm şirketler için kullanılabilir",
        "actions": " ",
        "add": "Soru ekle",
        "add_popup": "Soru ekle",
        "delete": "Soruyu sil",
        "edit": "Soruyu düzenle",
        "edit_popup": "Soruyu düzenle",
        "visibility": "Görünürlük",
        "visible_to_all": "Tüm kullanıcılara görünür",
        "visible_to_managers": "Yalnızca yöneticilere görünür"
    },
    "ai-connectors-page": {
        "title": "AI Bağlayıcıları",
        "is_shared": "Tüm kuruluşlar için kullanılabilir",
        "actions": " ",
        "add": "Bağlayıcı ekle",
        "add_popup": "Bağlayıcı ekle",
        "delete": "Bağlayıcıyı sil",
        "edit": "Bağlayıcıyı düzenle",
        "edit_popup": "Bağlayıcıyı düzenle",
        "label": "Etiket",
        "provider": "Sağlayıcı",
        "service": "Servis",
        "organization": "Kuruluş",
        "status": "Durum",
        "region": "Bölge",
        "endpoint": "Uç Nokta",
        "secret": "Parola/Anahtar",
        "maxConcurrency": "Maks. Eşzamanlılık",
        "timeoutSec": "Zaman Aşımı",
        "sortOrder": "Sıralama",
        "config": "Yapılandırma",
        "modelPrimary": "Primary modeli",
        "modelLight": "Light modeli",
        "modelLightHint": "Boşsa light çağrıları primary modelini kullanır",
        "folderId": "Folder ID",
        "models": "Modeller",
        "is_default": "Varsayılan",
        "notes": "Notlar"
    },
    "skills-page": {
        "title": "Başlık",
        "display_order": "Sıralama",
        "competence": "Yetkinlik",
        "text": "Göstergeler",
        "actions": " ",
        "add": "Beceri ekle",
        "add_popup": "Beceri ekle",
        "delete": "Beceriyi sil",
        "edit": "Beceriyi düzenle",
        "edit_popup": "Beceriyi düzenle"
    },
    "departments-page": {
        "title": "Başlık",
        "actions": " ",
        "add": "Departman ekle",
        "add_popup": "Departman ekle",
        "delete": "Departmanı sil",
        "edit": "Departmanı düzenle",
        "edit_popup": "Departmanı düzenle"
    },
    "tours-page": {
        "title": "Başlık",
        "actions": " ",
        "add": "Tur ekle",
        "add_popup": "Tur ekle",
        "delete": "Turu sil",
        "edit": "Turu düzenle",
        "edit_popup": "Turu düzenle"
    },
    "library-page": {
        "title": "Başlık",
        "text": "Açıklama",
        "video": "Video",
        "courses": "Kurslar",
        "video_link_copy": "Bağlantıyı kopyala",
        "video_in_process": "Video işleniyor...",
        "is_public": "Herkese açık",
        "actions": " ",
        "add": "Video ekle",
        "add_popup": "Video ekle",
        "delete": "Videoyu sil",
        "edit": "Videoyu düzenle",
        "edit_popup": "Videoyu düzenle"
    },
    "library-documents-page": {
        "title": "Başlık",
        "actions": " ",
        "add": "Belge ekle",
        "add_popup": "Belge ekle",
        "delete": "Belgeyi sil",
        "edit": "Belgeyi düzenle",
        "edit_popup": "Belgeyi düzenle",
        "file": "Dosya"
    },
    "scorm-page": {
        "title": "Başlık",
        "actions": " ",
        "add": "Kurs ekle",
        "loading": "Kurs yükleniyor...",
        "add_popup": "Kurs ekle",
        "delete": "Kursu sil",
        "edit": "Kursu düzenle",
        "edit_popup": "Kursu düzenle",
        "zip_file": "ZIP dosyası"
    },
    "ai-assistants-page": {
        "external_id": "ID",
        "description": "Açıklama",
        "actions": " ",
        "add": "AI asistanı ekle",
        "add_popup": "AI asistanı ekle",
        "delete": "AI asistanını sil",
        "edit": "AI asistanını düzenle",
        "edit_popup": "AI asistanını düzenle"
    },
    "ai-prompts-page": {
        "name": "Ad",
        "content": "İçerik",
        "actions": " ",
        "add": "AI prompt'u ekle",
        "add_popup": "AI prompt'u ekle",
        "delete": "AI prompt'unu sil",
        "edit": "AI prompt'unu düzenle",
        "edit_popup": "AI prompt'unu düzenle",
        "key": "Slot anahtarı",
        "model": "Model",
        "updated_at": "Güncellendi",
        "custom": "Özel",
        "description": "Açıklama",
        "temperature": "Sıcaklık",
        "top_p": "Top P",
        "reasoning_effort": "Akıl yürütme çabası",
        "reasoning_effort_default": "Varsayılan",
        "required_placeholders": "Zorunlu yer tutucular (içerikte bulunmalıdır)",
        "versions": "Sürüm geçmişi",
        "no_versions": "Henüz sürüm yok",
        "restore": "Geri yükle",
        "restore_confirm": "Bu sürüm geri yüklensin mi? İçeriği güncel sürüm haline gelecektir.",
        "restored": "Sürüm geri yüklendi",
        "current_version": "Güncel",
        "author": "Yazar",
        "error": "Bir şeyler ters gitti.",
        "tab_system": "Sistem",
        "tab_custom": "Özel",
        "system_hint": "Sistem prompt'ları platform kodu tarafından kullanılır. Silinemezler ancak içerikleri düzenlenebilir.",
        "custom_hint": "Özel prompt'lar, değerlendirme prompt'u geçersiz kılma (override) olarak yetkinliklere ve AI profillerine eklenir.",
        "model_from_code": "kod tarafından belirlenir",
        "model_from_code_hint": "Model, prompt'u kullanan kod tarafından seçilir; prompt'un kendisinde saklanmaz.",
        "used_by": "Kullanan",
        "used_by_value": "Yetkinlikler: {competencies}, AI profilleri: {profiles}",
        "not_used": "Kullanılmıyor",
        "delete_blocked_hint": "Silinemez: prompt bir geçersiz kılma (override) olarak kullanılıyor. {usage}",
        "slot_description": {
            "game_eval_negotiation": "PvP oyunlarının AI değerlendirmesi: müzakere",
            "game_eval_feedback": "PvP oyunlarının AI değerlendirmesi: geri bildirim",
            "game_eval_vs_ai": "AI'ya karşı oyunların AI değerlendirmesi (AI profilinde geçersiz kılma olmadığında)",
            "protocol_evaluation": "AI'ya karşı oyun dökümünden senaryo protokolünün doldurulması",
            "voice_agent": "Sesli AI muhatabı için sistem prompt'u",
            "scenario_generation": "Açıklamadan senaryo oluşturma",
            "scenario_card_update": "AI açıklamasından senaryo kartının güncellenmesi",
            "scenario_optimize": "Senaryonun AI açıklamasının optimize edilmesi",
            "skill_report_analysis": "Yetenek raporu: analiz adımı",
            "skill_report_recommendations": "Yetenek raporu: öneriler adımı"
        }
    },
    "evaluation-rubrics-page": {
        "name": "Ad",
        "actions": " ",
        "add": "Rubrik ekle",
        "add_popup": "Rubrik ekle",
        "edit": "Rubriği düzenle",
        "edit_popup": "Rubriği düzenle",
        "delete": "Rubriği sil",
        "updated_at": "Güncellendi",
        "hint": "Rubrikler, oyunları değerlendirmek için kullanılan ikili (evet/hayır) kontrol listelerini tanımlar. Bir yetkinliği kontrol listesi değerlendirmesine geçirmek için ona bir rubrik ekleyin.",
        "used_by": "Kullanan",
        "used_by_value": "Yetkinlikler: {count}",
        "not_used": "Kullanılmıyor",
        "delete_blocked_hint": "Silinemez: {count} yetkinlik tarafından kullanılıyor.",
        "criteria": "Kriterler",
        "criterion_text": "Kriter",
        "criterion_category": "Kategori (isteğe bağlı)",
        "add_criterion": "Kriter ekle",
        "criteria_hint": "Yeniden sıralamak için sürükleyin. İlgili kriterleri aynı kategoriyi vererek gruplandırın.",
        "drag_to_reorder": "Yeniden sıralamak için sürükleyin",
        "no_criteria": "En az bir kriter ekleyin.",
        "versions": "Sürüm geçmişi",
        "no_versions": "Henüz sürüm yok",
        "criteria_count": "{count} kriter",
        "restore": "Geri yükle",
        "restore_confirm": "Bu sürüm geri yüklensin mi? Güncel sürüm haline gelecektir.",
        "restored": "Sürüm geri yüklendi",
        "current_version": "Güncel",
        "author": "Yazar",
        "error": "Bir şeyler ters gitti."
    },
    "ai-profiles-page": {
        "name": "Ad",
        "settings": "Ayarlar",
        "temperature": "Hayal gücü",
        "demeanor": "Tavır",
        "behavior": "Davranış, talimatlar",
        "background": "Biyografi",
        "style": "Stil",
        "instructions": "Talimatlar",
        "supportive_phrases": "Destekleyici İfadeler",
        "ai_assistant": "AI Asistanı",
        "ai_starts_first": "Önce AI Başlar",
        "first_phrase": "İlk İfade",
        "closing_phrases": "Kapanış İfadeleri",
        "voice": "Ses",
        "expert_mode": "Uzman Modu",
        "custom_demeanor_hint": "Geçerli özel tavır",
        "is_shared": "Tüm organizasyonlar için kullanılabilir",
        "voice_options": {
            "male": "Erkek",
            "female": "Kadın"
        },
        "demeanor_options": {
            "friendly": {
                "title": "Dostane",
                "description": "Kolay yaklaşılabilir ve hoş"
            },
            "critical": {
                "title": "Eleştirel",
                "description": "Sık sık kusurları ve geliştirilmesi gereken alanları belirtir"
            },
            "empathetic": {
                "title": "Empatik",
                "description": "Başkalarının duygu ve hislerine karşı son derece duyarlı"
            },
            "enthusiastic": {
                "title": "Hevesli",
                "description": "Yoğun heyecan ve istek gösterir"
            },
            "analytical": {
                "title": "Analitik",
                "description": "Mantık ve ayrıntılı problem çözmeye odaklanır"
            },
            "curious": {
                "title": "Meraklı",
                "description": "Öğrenmeye ve soru sormaya isteklidir"
            },
            "assertive": {
                "title": "Girişken",
                "description": "Kendinden emin ve özgüvenli"
            },
            "blunt": {
                "title": "Dobra",
                "description": "Doğrudan ve öz"
            },
            "skeptical": {
                "title": "Şüpheci",
                "description": "Yeni çözüm ve fikirlere karşı temkinli"
            },
            "neutral": {
                "title": "Nötr",
                "description": "İletişim tarzında dengeli ve nesnel"
            },
            "casual": {
                "title": "Rahat",
                "description": "Tonu rahat ve sohbet havasında"
            }
        },
        "placeholders": {
            "name": "Örneğin: Sergey (kibar ve dostane)",
            "demeanor": "Örneğin: Dostane, kibar ve sosyal...",
            "background": "Örneğin: İki kez işten çıkarıldı...",
            "behavior": "Örneğin: Sözünü kesmez, aktif olarak dinler...",
            "first_phrase": "Örneğin: İyi günler! Ruh haliniz nasıl?",
            "closing_phrases": "Örneğin: Neredeyse hiç vaktimiz kalmadı, bu yüzden toplantımızı hızlıca özetlememizi öneriyorum."
        },
        "actions": " ",
        "add": "AI profili ekle",
        "add_popup": "AI profili ekle",
        "subtitle": "Görüşme partnerinin oturumda nasıl göründüğü ve duyulduğu",
        "preview": {
            "title": "Önizleme",
            "unnamed": "Adsız",
            "voice": "ses: {name}",
            "defaultVoice": "varsayılan ses",
            "defaultPhoto": "Varsayılan fotoğraf",
            "listen": "Sesi dinle",
            "defaultVoiceNotice": "Ses oturumun başında seçilecek — önceden dinlenemez",
            "photoPlaceholder": "Fotoğraf burada görünecek"
        },
        "delete": "AI profilini sil",
        "edit": "AI profilini düzenle",
        "edit_popup": "AI profilini düzenle",
        "avatar_hint": "avatar görseli",
        "avatar_save_first": "Avatar yüklemeyi etkinleştirmek için önce profili kaydedin",
        "avatar_requirements": "Maks. 1 MB • Önerilen: 1536×1024 • En-boy oranı: 3:2",
        "max_characters": "En fazla {max} karakter"
    },
    "games-page": {
        "game-with-ai": "AI ile Rol Yapma",
        "organization": "Organizasyon",
        "status": "Durum",
        "failure_reasons": {
            "protocol_not_agreed": "Protokol katılımcılar tarafından kabul edilmedi",
            "protocol_approval_expired": "Protokol onay süresi doldu",
            "annulled": "Oturum iptal edildi",
            "expired": "Oturum süresi doldu",
            "assignment_changed": "Öğrenme sistemindeki kurs ataması değişti"
        },
        "restore": "Geri yükle",
        "play": "Oyna",
        "meetings_unavailable": "Katılımcılar arasındaki görüntülü oturumlar geçici olarak kullanılamıyor. Lütfen daha sonra tekrar deneyin.",
        "import": "İçe aktar",
        "scenario": "Senaryo",
        "tour": "Tur",
        "game_types": {
            "classic": "Klasik mod",
            "vs_ai": "AI ile Rol Yapma",
            "uploaded_recording": "Kayıt"
        },
        "upload_recording": {
            "file": "Kayıt dosyası",
            "file_hint": "Video veya ses, 1 GB'a kadar",
            "uploaded": "Dosya yüklendi",
            "file_too_large": "Dosya 1 GB'ı aşıyor",
            "upload_error": "Dosya yüklenemedi",
            "player": "Katılımcı",
            "rate_both": "Her iki katılımcıyı değerlendir",
            "second_player": "İkinci katılımcı",
            "open_session": "Oturumu aç"
        },
        "game_targets": {
            "user": "Katılımcı",
            "position": "Pozisyon",
            "department": "Departman"
        },
        "number": "Numara",
        "start_up_to": "En geç başlangıç",
        "start_time": "Başlangıç zamanı",
        "teamA": "A Takımı",
        "teamB": "B Takımı",
        "others": "Katılımcılar",
        "actions": " ",
        "edit_results": "Sonuçları değiştir",
        "add": "Oturum ekle",
        "add_popup": "Oturum ekle",
        "delete": "Oturumu sil",
        "edit": "Oturumu düzenle",
        "edit_popup": "Oturumu düzenle",
        "time_scheduling": "Başlangıç zamanı planlama",
        "return_to_time_scheduling": "Başlangıç zamanı planlamasına dön",
        "preparation": "Oturuma hazırlık",
        "view_scenario": "Senaryoyu görüntüle",
        "protocol": "Protokol onayı",
        "not_agreed": "Onaylanmadı",
        "expert-accept": "Kabul et ve değerlendirmeye geç",
        "expert-decline": "Reddet",
        "hide_ai_results": "AI sonuçlarını gizle",
        "show_ai_results": "AI sonuçlarını göster",
        "mark_completed": "Tamamlandı olarak işaretle",
        "mark_failed": "Başarısız olarak işaretle",
        "popup": {
            "start_up_to": "En geç başlangıç",
            "target": "Oturum kime atanmalı?",
            "custom_field_value": "“{field}” alanının değeri",
            "target_preview_count": "Oluşturulacak oturumlar: {count}",
            "target_preview_empty": "Bu hedefe uyan oyuncu yok — hiçbir oturum oluşturulmayacak",
            "target_preview_limit_exceeded": "Bu, tek bir atamada oluşturulabilecek sayıdan fazla (en fazla {limit}). Kesiti, vaka sayısını veya kopya sayısını azaltın",
            "copies_per_player": "Oyuncu başına her vakanın kopyası",
            "position": "Pozisyon",
            "department": "Departman",
            "scenario": "Senaryo",
            "optional": "İsteğe bağlı, boş bırakılabilir",
            "protocol_time": "Protokol süresi",
            "protocol_time_hint": "1 ile 1440 arasında bir sayı",
            "preparation_time": "Hazırlık süresi",
            "preparation_time_hint": "Dakika cinsinden",
            "game_duration": "Oturum süresi",
            "game_duration_hint": "1 ile 60 arasında bir sayı",
            "is_team": "Takımlar için senaryo",
            "is_camera_required": "Katılımcı kameraları zorunludur",
            "is_self_rated": "Katılımcılar kendilerini değerlendirebilir",
            "is_each_other_rated": "Katılımcılar birbirlerini değerlendirebilir",
            "is_expert_rated": "Uzman değerlendirmesi mevcuttur",
            "is_ai_rated": "AI değerlendirmesi mevcuttur",
            "show_results": "Sonuçları göster",
            "automatically": "otomatik olarak",
            "manually": "manuel olarak",
            "is_public_hint": "Herhangi bir gözlemci bağlanabilir",
            "is_public": "Herkese açık oturum",
            "team_a": "A Takımı",
            "team_b": "B Takımı",
            "player_a": "Katılımcı A",
            "player_b": "Katılımcı B",
            "expert": "Uzman",
            "observers": "Gözlemciler",
            "tour": "Tur",
            "search": "Ara...",
            "choose_players": "Katılımcıları seç",
            "choose_expert": "Uzman seç",
            "choose_observers": "Gözlemcileri seç",
            "choose_scenario": "Senaryo seç",
            "choose_tour": "Tur seç",
            "expert_empty": "Seçilmezse, kaptan seçim yapabilecektir",
            "captain": "Kaptan",
            "": "",
            "protocol": {
                "title": "Protokol onayı",
                "target": "Hedef",
                "await_approval": "Rakibin onayını bekleyin",
                "await_proposal": "Rakibin teklifini bekleyin",
                "questions": "Takımınız için sorular",
                "questions_a": "A takımı için sorular",
                "questions_b": "B takımı için sorular",
                "not_agreed": "Anlaşmaya varılamadı",
                "not_agreed_confirm": "Oturum başarısız şekilde sona erecek ve sonuçlar sayılmayacaktır. Bu işlem geri alınamaz.",
                "not_agreed_done": "Oturum başarısız şekilde sona erdi."
            },
            "start_time": {
                "title": "Başlangıç zamanı",
                "must_start_by": "Şu tarihe kadar başlamalı"
            },
            "edit_results": {
                "title": "Sonuçları değiştir"
            },
            "preparation": {
                "title": "Oturuma hazırlık",
                "description": "Açıklama",
                "description_team": "Takım açıklaması",
                "notes": "Kişisel notlar"
            },
            "import": {
                "download_example": "Örnek indir",
                "title": "Oturumları içe aktar",
                "button": "İçe aktarmayı başlat",
                "label": "Excel dosyası",
                "file_size_error": "Dosya boyutu 10 MB'den küçük olmalıdır"
            },
            "create_multi_scenario_games_immediately": "Tüm oturumlar hemen oluşturulacaktır",
            "create_multi_scenario_games_sequentially": "Oturumlar sırayla oluşturulacaktır (her biri başarıyla tamamlandıktan sonra)"
        }
    },
    "ai-game": {
        "title": "AI ile Rol Yapma",
        "recording": "Kayıt",
        "ai": "AI",
        "you": "Siz",
        "ai_ready": "Hazır",
        "camera_off": "Kamera kapalı",
        "stop_game": "Durdur",
        "start_game": "Başlat",
        "mic_permission": "Oturumu başlatmak için lütfen ayarlardan mikrofon izni verin",
        "permissions_granted": "İzinler başarıyla verildi!",
        "close": "Kapat",
        "microphone_required": "Oturumu başlatmak için lütfen mikrofon izni verin",
        "mic_required": "Oturumu başlatmak için mikrofonu açın",
        "mic_not_detected": "Henüz ses algılanmadı — konuşmayı deneyin veya mikrofonunuzu kontrol edin",
        "permissions_needed": "Mikrofon erişimi gereklidir. Kamera isteğe bağlıdır",
        "dialog_history": "Diyalog Geçmişi",
        "agent": {
            "initializing": "Başlatılıyor...",
            "listening": "Dinleniyor",
            "thinking": "Düşünüyor...",
            "speaking": "Konuşuyor",
            "waiting": "Ajan bekleniyor..."
        },
        "waiting_for_start": "Konuşmaya başlamak için oturumu başlatın",
        "grant_microphone": "Mikrofon Erişimi Ver",
        "game_not_found": "Oturum Bulunamadı",
        "game_not_found_desc": "{id} kimlikli oturum bulunamadı.",
        "confirm": {
            "start_question": "Emin misiniz? Oturum duraklatılamaz",
            "start_title": "Oturum Başlatıldı",
            "start_success": "Oturum başarıyla başlatıldı",
            "start_cancel_title": "Oturum Başlatılmadı",
            "start_cancel_msg": "Oturum başlatma iptal edildi",
            "end_question": "Emin misiniz? Oturum sona erdirilecek",
            "end_title": "Oturum Sona Erdi",
            "end_success": "Oturum başarıyla sona erdirildi",
            "end_cancel_title": "Oturum Sona Erdirilmedi",
            "end_cancel_msg": "Oturumu sona erdirme iptal edildi"
        },
        "voice": {
            "disconnected": "Bağlantı kesildi",
            "connecting": "Bağlanıyor...",
            "connection_lost_permanently": "Bağlantı kesildi. Oturum ağ sorunları nedeniyle sona erdi.",
            "connected": "Sunucuya bağlandı",
            "connection_error": "Sesli ajana bağlanılamadı",
            "game_already_finished": "Bu oyun zaten tamamlandı",
            "connection_timeout": "Sesli sunucuya bağlantı zaman aşımına uğradı. Bu bir güvenlik duvarı veya ağ kısıtlamasından kaynaklanıyor olabilir. Ağ ayarlarınızı kontrol edip tekrar deneyin.",
            "no_rooms_available": "Şu anda kullanılabilir oda yok. Lütfen daha sonra tekrar deneyin.",
            "preparing_recording": "Kayıt hazırlanıyor, {seconds} saniye içinde tekrar denenecek…",
            "recording_service_overloaded": "Kayıt servisi aşırı yüklü. Lütfen birkaç dakika içinde tekrar deneyin.",
            "session_quota_exhausted": "Kuruluşunuzun oturum paketi tükendi. Lütfen yöneticinizle iletişime geçin.",
            "connection_blocked": "Ağınız AI bağlantı kurulumunu engelledi. Gerekli alan adlarına HTTPS (443) erişimine izin verin, ardından tekrar deneyin.",
            "connection_blocked_signaling": "Ağınızın güvenlik duvarı veya proxy'si sesli sunucuya olan bağlantıyı engelliyor. Farklı bir ağdan veya mobil hotspot üzerinden bağlanmayı deneyin.",
            "reconnecting": "Yeniden bağlanıyor...",
            "disconnect_dialog_title": "Bağlantı Kesildi",
            "disconnect_dialog_message": "Bağlantı kesintiye uğradı. Yeniden bağlanmak mı yoksa oturumu sonlandırmak mı istersiniz?",
            "disconnect_retry": "Yeniden Bağlan",
            "disconnect_finish": "Oturumu Sonlandır",
            "agent_join_timeout": "AI ajanı zamanında bağlanamadı. Lütfen tekrar deneyin.",
            "stop_failed": "Oturum durdurulamadı",
            "mic_enable_failed": "Mikrofon etkinleştirilemedi. Manuel olarak açıp kapatmayı deneyebilirsiniz.",
            "mic_toggle_failed": "Mikrofon açılıp kapatılamadı",
            "camera_toggle_failed": "Kamera açılıp kapatılamadı",
            "duplicate_tab_title": "Oturum Başka Bir Sekmede Açık",
            "duplicate_tab_message": "Bu oturum başka bir tarayıcı sekmesinde zaten aktif. Buradan devam etmek istiyorsanız diğer sekmeyi kapatıp bu sayfayı yeniden açın.",
            "duplicate_tab_back": "Geri Dön",
            "duplicate_tab_disconnect_title": "Başka Bir Sekmede Açıldı",
            "duplicate_tab_disconnect_message": "Oturum başka bir sekmede zaten aktif olduğu için bu sekmenin bağlantısı kesildi. Oturum sayfasına buradan geri dönün."
        },
        "pending_chunks_title": "Kaydedilmemiş Kayıt Verisi",
        "pending_chunks_desc": "Önceki bir oturumdan kaydedilmemiş kayıt verisi var. Yüklemeye devam etmek ister misiniz?",
        "pending_chunks_uploaded": "Bekleyen tüm kayıtlar başarıyla yüklendi",
        "resume_upload": "Yüklemeye Devam Et",
        "skip": "Atla",
        "permissions_denied_safari": "Kamera veya mikrofon erişimi reddedildi. Lütfen Safari Ayarları > Web Siteleri > Kamera/Mikrofon bölümüne gidip bu site için erişime izin verin.",
        "supported": "Tarayıcı destekleniyor"
    },
    "positions-page": {
        "title": "Unvan",
        "actions": " ",
        "add": "Pozisyon ekle",
        "add_popup": "Pozisyon ekle",
        "delete": "Pozisyonu sil",
        "edit": "Pozisyonu düzenle",
        "edit_popup": "Pozisyonu düzenle"
    },
    "user-custom-fields-page": {
        "title": "Başlık",
        "type": "Tür",
        "options_count": "Değerler",
        "actions": " ",
        "add": "Alan ekle",
        "add_popup": "Alan ekle",
        "delete": "Alanı sil",
        "delete_confirm": "Alan silinsin mi? Kullanıcılar için saklanan değerler artık gösterilmeyecek.",
        "edit": "Alanı düzenle",
        "edit_popup": "Alanı düzenle",
        "empty": "Henüz özel alan yok",
        "error": "Alan kaydedilemedi",
        "type_text": "Metin",
        "type_select": "Sözlük",
        "type_locked_hint": "Alan oluşturulduktan sonra türü değiştirilemez",
        "options": "Değerler",
        "options_hint": "Buradaki değerlerin sırası, açılır listedeki sırayla aynıdır",
        "options_required": "En az bir değer ekleyin",
        "option_title": "Değer",
        "option_add": "Değer ekle",
        "option_delete": "Değeri sil",
        "option_delete_confirm": "Değer silinsin mi? Bu değeri seçmiş olan kullanıcılar için temizlenecektir.",
        "option_move_up": "Yukarı taşı",
        "option_move_down": "Aşağı taşı"
    },
    "organizations-page": {
        "name": "Ad",
        "host": "Alan Adı",
        "duel_limit": "Düello sınırı",
        "max_users": "Maks. kullanıcı",
        "max_users_hint": "0 = sınırsız",
        "max_vs_ai_games_per_scenario": "Senaryo başına oyuncu için maks. AI oyunu",
        "max_vs_ai_games_per_scenario_hint": "Boş — sınır yok. Oyuncuların kendi kendine oyun oluşturmasına uygulanır",
        "employee_report_daily_limit": "Çalışan raporları için günlük sınır",
        "employee_report_daily_limit_hint": "Boş — platform geneli sınır. Yöneticiler ve ekip liderleri için geçerlidir",
        "employee_report_hourly_limit": "Çalışan raporları için saatlik sınır",
        "employee_report_hourly_limit_hint": "Boş — platform geneli sınır. Yöneticiler ve ekip liderleri için geçerlidir",
        "registration": "Kayıt açık",
        "timezone": "Saat Dilimi",
        "locale": "Yerel Ayar",
        "users_count": "Kullanıcılar",
        "actions": " ",
        "add": "Kuruluş ekle",
        "add_popup": "Kuruluş ekle",
        "delete": "Kuruluşu sil",
        "edit": "Kuruluşu düzenle",
        "edit_popup": "Kuruluşu düzenle",
        "available_languages": "Kullanılabilir diller",
        "show_game_numbers_for_player": "Katılımcı için oturum numaralarını göster",
        "allow_players_choose_expert": "Katılımcıların uzman seçmesine izin ver",
        "send_message": "Yöneticilere mesaj gönder",
        "message": "Mesaj",
        "send": "Gönder",
        "clear_message": "Mesajı temizle",
        "current_message": "Mevcut mesaj",
        "two_factor_available": "İki Faktörlü Kimlik Doğrulama Kullanılabilir",
        "two_factor_method": "İki Faktörlü Kimlik Doğrulama Yöntemi",
        "two_factor_disabled": "Devre Dışı",
        "two_factor_email": "E-posta",
        "two_factor_sms": "SMS",
        "hidden_menu_items": "Gizli menü öğeleri",
        "hide_ai_results": "AI sonuçlarını gizle",
        "hide_player_rating": "Şirket sıralamasını katılımcılardan gizle",
        "show_character_memory_to_player": "Karakter hafızasını oyuncuya göster",
        "show_meeting_recap_to_player": "Görüşme özetini oyuncuya göster",
        "create_user_on_external_launch": "Harici sistemden gelen ilk istekte kullanıcı oluştur",
        "create_user_on_external_launch_hint": "Kapalıyken, harici sistemden ilk kez gelen bir katılımcı oyun almak yerine reddedilir. Bu şekilde oluşturulan her kullanıcı abonelikte bir yer kaplar.",
        "allow_external_email_linking": "Harici kullanıcının e-posta ile eşleştirilmesine izin ver",
        "allow_external_email_linking_hint": "Açıkken, harici sistem e-posta adresini kendi sunucusundan bildirdiyse, harici kişi mevcut bir çalışanla eşleştirilir. Kapalıyken bu istek reddedilir ve aynı e-posta adresine sahip ikinci bir kullanıcı oluşturulmaz."
    },
    "users-page": {
        "import": "İçe aktar",
        "user": "Kullanıcı",
        "roles": "Roller",
        "effectiveness": "Etkinlik",
        "department": "Departman",
        "position": "Pozisyon",
        "status": "Durum",
        "actions": " ",
        "add": "Kullanıcı ekle",
        "add_popup": "Yeni kullanıcı",
        "last_login_at": "Son giriş",
        "delete": "Sil",
        "view": "Görüntüle",
        "login": "Giriş yap",
        "message": "Mesaj",
        "activate": "Etkinleştir",
        "deactivate": "Engelle",
        "edit_popup": "Kullanıcıyı düzenle",
        "total_in_org": "Kuruluşta toplam",
        "multi_role_note": "Birden fazla rolü olan bir kullanıcı her rozette sayılır",
        "filter_role": "Rol",
        "all_roles": "Tüm roller",
        "filter_activity": "Tamamlanan senaryolar",
        "activity_played": "Evet",
        "activity_not_played": "Hayır",
        "filter_activity_from": "Şu tarihten beri oynandı",
        "filter_last_login_from": "Giriş tarihi",
        "filter_custom_field": "Özel alan",
        "filter_custom_field_value": "“{field}” alanının değeri",
        "last_login_never": "Hiç giriş yapmadı",
        "last_login_since": "Şu tarihten beri giriş yaptı",
        "cases_progress": "Tamamlanan vakalar",
        "cases_progress_value": "{completed} / {assigned}",
        "export": "Dışa Aktar",
        "popup": {
            "name": "Ad",
            "last_name": "Soyad",
            "patronymic": "Baba adı",
            "phone": "Telefon",
            "timezone": "Saat dilimi",
            "language": "Dil",
            "country": "Ülke",
            "invalid_phone": "Geçersiz telefon numarası",
            "department": "Departman",
            "position": "Pozisyon",
            "effectiveness": "Etkinlik",
            "roles": "Roller",
            "organizations": "Organizasyonlar",
            "blocked": "Engellendi",
            "is_active": "Aktif",
            "email_verified": "E-posta doğrulandı",
            "email_not_verified": "E-posta doğrulanmadı",
            "subordinates": "Astlar",
            "search_subordinates": "Katılımcı ara...",
            "import": {
                "download_example": "Örnek indir",
                "title": "Kullanıcıları içe aktar",
                "button": "İçe aktarmayı başlat",
                "label": "Excel dosyası",
                "marker_hint": "Zaten var olan bir kullanıcı için boş hücre mevcut değeri korur, tire (-) ise alanı temizler.",
                "result_title": "İçe aktarma başlatıldı",
                "result_created": "Oluşturulacak: {count}",
                "result_updated": "Güncellenecek: {count}",
                "result_skipped": "Atlanan: {count}",
                "result_skipped_row": "Satır {row}, {email}: {reason}",
                "result_truncated": "…ve atlanan {count} satır daha"
            }
        }
    },
    "users-ranking-page": {
        "user": "Kullanıcı",
        "roles": "Roller",
        "effectiveness": "Etkinlik",
        "average-effectiveness": "Oturum başına ort.",
        "sessions-count": "Oturumlar",
        "department": "Departman",
        "position": "Pozisyon",
        "status": "Durum",
        "export": "Dışa Aktar",
        "actions": " "
    },
    "user-detail": {
        "games_finished": "Tamamlanan Oturumlar",
        "not_found": "Kullanıcı bulunamadı",
        "games_total": "Toplam",
        "username": "Kullanıcı Adı",
        "phone": "Telefon",
        "status": "Durum",
        "language": "Dil",
        "timezone": "Saat Dilimi",
        "edit": "Düzenle",
        "department": "Departman",
        "position": "Pozisyon",
        "activate": "Etkinleştir",
        "block": "Engelle",
        "account": {
            "title": "Hesap",
            "summary": {
                "title": "Özet",
                "games": "Oynanan oturumlar",
                "place": "Sıra",
                "effectiveness": "Etkinlik",
                "time": "Süre"
            }
        },
        "security": {
            "title": "Güvenlik",
            "change_password_title": "Şifre değiştir",
            "change_password": "Şifre değiştir",
            "new_password": "Yeni şifre",
            "confirm_new_password": "Yeni şifreyi onayla",
            "password_requirements": "Şifre Gereksinimleri:",
            "password_requirements_1": "En az 8 karakter uzunluğunda - ne kadar uzunsa o kadar iyi",
            "password_requirements_2": "En az bir küçük harf",
            "password_requirements_3": "En az bir rakam, sembol veya boşluk karakteri"
        },
        "statistics": {
            "title": "İstatistikler"
        }
    },
    "game": {
        "character_memory": {
            "title": "Karakterin hatırladıkları",
            "subtitle": "Karakterin bu oyuna taşıdığı geçmiş görüşme hafızası",
            "preview_subtitle": "Hafıza henüz oluşturulmadı — karakter onu oyunun başladığı anda alacak",
            "unavailable": "Önceki görüşme karakter için erişilebilir değil: karakter bu görüşmeyi hatırlamadan konuşmaya başlayacak.",
            "agreements": "Mutabakatlar",
            "player_commitments": "Oyuncunun taahhütleri",
            "character_commitments": "Karakterin taahhütleri",
            "open_issues": "Açık sorular",
            "facts": "Belirtilen gerçekler",
            "attitude": "Oyuncuya karşı tutum",
            "evaluation_passed": "O görüşmenin değerlendirme sonuçları karaktere aktarıldı",
            "evaluation_not_ready": "O görüşmenin değerlendirmesi henüz hazır değil — hesaplandığında karakter onu alacak.",
            "evaluation_hidden": "Değerlendirme metinleri kuruluş ayarlarıyla gizlenmiştir.",
            "overall_effectiveness": "Genel etkinlik",
            "outcome": {
                "deal": "Anlaşma",
                "partial": "Kısmi",
                "no_deal": "Anlaşma yok",
                "unclear": "Sonuç belirsiz"
            }
        },
        "meeting_recap": {
            "title": "Görüşme özeti",
            "outcome": "Görüşmenin sonucu",
            "agreements": "Mutabakatlar",
            "player_commitments": "Oyuncunun taahhütleri",
            "character_commitments": "Karakterin taahhütleri",
            "open_issues": "Açık sorular",
            "facts": "Belirtilen gerçekler",
            "pending": "Görüşme özeti henüz hazırlanıyor. Lütfen daha sonra tekrar deneyin.",
            "unavailable": "Bu görüşmenin özeti oluşturulamadı.",
            "none": "Bu oyun için özet bulunmuyor."
        },
        "title": "Oturum",
        "team": "Takım",
        "expert": "Uzman",
        "points": "puan",
        "your_result": "Sonucunuz",
        "joined_at": "Katılım:",
        "ended_at": "Tamamlanma tarihi",
        "min": "dk.",
        "duration": "Süre",
        "from_average": "ortalamadan",
        "ai_expert": "AI Uzman",
        "ai_evaluation_in_progress": "AI değerlendirmesi devam ediyor",
        "delete_ai_request": "AI geri bildirimini sil",
        "ai_expert_refresh": "AI Sonuçlarını Yenile",
        "ai_expert_refresh_rejected": {
            "evaluation_not_completed": "AI sonuçları şu anda yenilenemiyor: AI değerlendirmesi hâlâ devam ediyor.",
            "answer_pending": "AI sonuçları şu anda yenilenemiyor: AI yanıtı henüz gelmedi.",
            "recognition_pending": "AI sonuçları şu anda yenilenemiyor: kaydın dökümü hâlâ çıkarılıyor.",
            "recognition_has_no_speech": "Kayıtta konuşma tanınmadı, bu nedenle AI sonuçları yenilenemez.",
            "recognition_has_too_little_speech": "Kayıtta katılımcılar arasında neredeyse hiç konuşma yok, bu nedenle AI değerlendirmesi yapılmadı.",
            "no_ai_evaluation": "Bu oturumun artık bir AI değerlendirmesi yok.",
            "game_evaluation_blocked": "Oturum gerçekleşmedi veya iptal edildi, bu nedenle AI değerlendirmesi kullanılamıyor."
        },
        "ai_expert_unavailable": {
            "recognition_has_no_speech": "Kayıtta konuşma tanınmadı, bu nedenle AI değerlendirmesi yapılmadı.",
            "recognition_has_too_little_speech": "Kayıtta katılımcılar arasında neredeyse hiç konuşma yok, bu nedenle AI değerlendirmesi yapılmadı.",
            "game_evaluation_blocked": "Oturum gerçekleşmedi veya iptal edildi, bu nedenle AI değerlendirmesi kullanılamıyor."
        },
        "ai_expert_refresh_failed": "AI sonuçları yenilenemedi.",
        "speaker_mapping": {
            "title": "Katılımcılar ve sesler",
            "voice": "Ses {number}",
            "unknown": "Belirlenmedi",
            "needs_review": "Katılımcıları kontrol edin",
            "needs_review_hint": "Katılımcılar yanlış belirlenmiş olabilir: AI geri bildiriminin doğru kişilere ulaştığından emin olun.",
            "failed": "Katılımcılar otomatik olarak belirlenemedi.",
            "unavailable": "Yapay zeka sağlayıcısı kullanılamıyordu; katılımcılar bir sonraki değerlendirmede belirlenecek.",
            "empty": "Dökümde katılımcıları belirlemek için kullanılabilecek herhangi bir konuşma yok.",
            "corrected_manually": "Elle düzeltildi",
            "under_reevaluation": "Bu katılımcılarla AI değerlendirmesi devam ediyor. Tamamlanana kadar sayfada önceki sonuçlar görünür.",
            "confirm": "Katılımcılar doğru",
            "review": "İncele",
            "dialog_hint": "Her sese bir katılımcı atayın. Kaydettikten sonra AI geri bildirimi yeniden istenecek.",
            "save": "Kaydet",
            "cancel": "İptal",
            "confirmed": "Katılımcılar onaylandı",
            "fixed": "Katılımcılar düzeltildi, AI geri bildirimi yeniden istendi",
            "action_failed": "İşlem tamamlanamadı"
        },
        "ai_expert_created": "Oturum değerlendirme süreci başladı. Bu birkaç dakika sürecek. Sayfadan ayrılabilirsiniz, değerlendirme hazır olduğunda size bildirim göndereceğiz.",
        "expert_already_requested": "Değerlendirme başka bir katılımcı tarafından zaten talep edildi",
        "request_expert": "Uzman Talep Et",
        "assign_expert": "Uzman Ata",
        "ai_process": "Lütfen bekleyin, işleniyor",
        "analyzing_results": "Oturum sonuçları analiz ediliyor...",
        "complete_expert_request": "Değerlendirmeyi tamamla",
        "tabs": {
            "description": {
                "title": "Senaryo Açıklaması",
                "subtitle": "Oturum bilgileri ve kuralları",
                "situation": "Durum",
                "your_role": "Rolünüz",
                "player_role": "Katılımcı rolü: {name}",
                "team_tab": "{team} Takımı",
                "empty": "Bu oturumda açıklama yok.",
                "load_error": "Açıklama yüklenemedi. Lütfen daha sonra tekrar deneyin."
            },
            "results": {
                "title": "Sonuçlar",
                "effectiveness_summary": "Takım etkinliği",
                "your_effectiveness": "Sizin etkinliğiniz",
                "parameters_section": "Parametreler",
                "parameter": "Parametre",
                "target": "Hedef",
                "coefficient": "Katsayı",
                "value": "Anlaşma",
                "points": "Puanlar",
                "points_short": "puan",
                "combinations": "Kombinasyonlar",
                "combination_bonus": "Kombinasyon bonusu",
                "questions": "Sorular",
                "question": "Soru",
                "answer": "Cevap",
                "total": "Toplam"
            },
            "comments": {
                "title": "Video Analizi",
                "comments": "Yorumlar",
                "no_comments": "Henüz yorum yok",
                "no_video": "Video mevcut değil",
                "video_processing": "Video işleniyor...",
                "count": "yorum",
                "delete": "Sil",
                "edit": "Düzenle",
                "popup": {
                    "add": "Yorum ekle",
                    "edit": "Yorumu düzenle",
                    "comment": "Yorum",
                    "player": "Katılımcı",
                    "all": "Herkese"
                }
            },
            "feedback": {
                "title": "Oturum Değerlendirmesi",
                "no_feedback": "Henüz değerlendirme yok",
                "no_feedback_description": "Bu oturum için geri bildirim henüz eklenmedi",
                "overall_score": "Genel Puan",
                "skills_evaluated": "{count} beceri değerlendirildi",
                "no_comment": "Yorum eklenmedi",
                "score_button": "Katılımcıyı Değerlendir",
                "player": "Katılımcı",
                "author": "Yazar",
                "download": "Videoyu indir",
                "download_transcript": "Dökümü indir",
                "evaluators": {
                    "ai": "Uzman",
                    "expert": "Uzman",
                    "player": "Katılımcı",
                    "manager": "Yönetici",
                    "head": "Ekip Lideri"
                },
                "popup": {
                    "score": {
                        "title": "Katılımcı Değerlendirmesi",
                        "comment": "Yorum",
                        "error": "Katılımcının tüm becerilerini değerlendirmelisiniz",
                        "save_error": "Değerlendirme kaydedilemedi. Bu katılımcıyı değerlendirme yetkiniz olmayabilir."
                    }
                }
            },
            "checklist": {
                "title": "Kontrol Listesi",
                "total": "Geçilen maddeler",
                "pass": "Geçti",
                "fail": "Kaldı",
                "cannot_assess": "Değerlendirilemez",
                "comment": "Genel yorum",
                "category": "Kategori",
                "author": "Değerlendiren",
                "player": "Katılımcı",
                "passed_of": "{total} üzerinden {passed}",
                "evidence": "Kanıt",
                "rationale": "Gerekçe",
                "no_results": "Henüz kontrol listesi değerlendirmesi yok",
                "no_results_description": "Bu oturum henüz bir kontrol listesine göre değerlendirilmedi"
            }
        }
    },
    "scenario": {
        "steps": {
            "information": {
                "create_new_ai_profile": "Yeni Oluştur",
                "edit_ai_profile": "Düzenle",
                "delete_ai_profile": "Sil",
                "confirm_delete_ai_profile": "Bu AI profilini silmek istediğinizden emin misiniz?",
                "first_header": "Temel Ayarlar",
                "second_header": "AI Oyuncu",
                "third_header": "Senaryo Açıklaması",
                "is_public": "Herkese Açık",
                "is_public_hint": "Etkinleştirilirse — senaryo katılımcılar tarafından seçilebilir olacaktır.",
                "title": "Bilgi",
                "subtitle": "Senaryo temel verileri",
                "image": "senaryo görseli",
                "field_title": "Başlık",
                "competence": "Yetkinlik",
                "description": "Açıklama",
                "description_a": "A takımı için açıklama",
                "description_b": "B takımı için açıklama",
                "next_scenario_label": "Sonraki Senaryo",
                "next_scenario_placeholder": "Seçilmedi",
                "next_scenario_hint": "Bu senaryoyla oturum tamamlandıktan sonra, sonraki senaryoyla otomatik olarak bir oturum oluşturulacaktır.",
                "memory_header": "Sonraki görüşmeyle bağlantı",
                "memory_group_evaluation": "Sonraki görüşmenin değerlendirmesi",
                "memory_group_character": "Sonraki görüşmenin karakteri",
                "memory_pass_to_next": "bu görüşmeyi hatırlıyor",
                "memory_pass_to_next_hint": "Sonraki senaryonun karakteri, görüşmeye sanki tanıdığı biriyle konuşuyormuş gibi başlar: bu görüşmenin kısa bir özetini, mutabakatları, tarafların taahhütlerini, açık soruları ve belirtilen gerçekleri alır. Görüşmenin kaydı ve birebir alıntılar kendisine aktarılmaz. Bir sonraki görüşme bunun devamıysa bu seçeneği açın: müzakerenin ikinci turu, düzenli tekrarlanan birebir görüşme.",
                "memory_pass_evaluation_to_next": "bu görüşmenin değerlendirme sonuçlarını biliyor",
                "memory_pass_evaluation_to_next_hint": "Hafızayla birlikte karakter, bu görüşmenin beceri geri bildirim metinlerini ve genel sonucunu da alır; böylece oyuncunun neyi başardığını hatırlayan bir koç gibi davranabilir.",
                "memory_evaluate_next_with_agreements": "bu görüşmenin mutabakatlarını dikkate alır",
                "memory_evaluate_next_with_agreements_hint": "Sonraki görüşme değerlendirilirken AI uzmanı, bu görüşmenin mutabakatlarını, tarafların taahhütlerini ve açık sorularını görür; böylece oyuncunun sözünü tutup tutmadığını kontrol edebilir. Önceki değerlendirmenin puanları ve metinleri uzmana aktarılmaz; böylece yeni değerlendirmeyi etkilemez.",
                "ai_profile": "AI Profili",
                "ai_profile_placeholder": "Yalnızca AI maçları için",
                "ai_description": "AI Açıklaması",
                "optimize_ai_description": "AI ile optimize et",
                "optimizing_in_progress": "AI açıklamayı optimize ediyor. Lütfen bekleyin...",
                "optimize_error": "Açıklama optimize edilemedi. Lütfen tekrar deneyin.",
                "ai_description_hint": "Etkili bir AI prompt'u yazmak deneyim gerektirir. Kötü yazılmış bir prompt, senaryonun öngörülemeyen şekilde davranmasına yol açabilir. Emin değilseniz \"AI ile optimize et\" düğmesini kullanın, senaryo oluşturma özelliğini deneyin veya yardım için yöneticinizle iletişime geçin.",
                "knowledge_base_header": "Bilgi Tabanı",
                "knowledge_base_documents": "Bilgi Tabanı Belgeleri",
                "knowledge_base_documents_hint": "AI oyuncusuna bağlam sağlamak için belgeler ekleyin",
                "knowledge_base_no_documents": "Kullanılabilir belge yok. Belgeleri \"Bilgi Tabanı\" sayfasından yükleyin.",
                "knowledge_base_chunks": "{count} parça",
                "knowledge_base_purpose_voice": "AI oturumu",
                "knowledge_base_purpose_eval": "Değerlendirme"
            },
            "settings": {
                "title": "Ayarlar",
                "subtitle": "Senaryo yapılandırması",
                "min_players": "Min. katılımcı",
                "min_players_hint": "2 ile 20 arasında bir sayı",
                "max_players": "Maks. katılımcı",
                "max_players_hint": "2 ile 20 arasında bir sayı",
                "protocol_time": "Protokol süresi (dk)",
                "protocol_time_hint": "1 ile 1440 arasında bir sayı",
                "preparation_time": "Hazırlık süresi (dk)",
                "preparation_time_hint": "0 ile 1440 arasında bir sayı. 0 - açıklama hemen görünür olur",
                "game_duration": "Oturum süresi (dk)",
                "game_duration_hint": "1 ile 60 arasında bir sayı",
                "is_team": "Takımlar için senaryo",
                "is_camera_required": "Katılımcı kameraları zorunludur",
                "is_self_rated": "Katılımcılar kendilerini değerlendirebilir",
                "is_each_other_rated": "Katılımcılar birbirlerini değerlendirebilir",
                "is_expert_rated": "Uzman değerlendirmesi mevcuttur",
                "is_ai_rated": "AI değerlendirmesi mevcuttur",
                "show_results": "Sonuçları göster",
                "automatically": "otomatik olarak",
                "manually": "manuel olarak"
            },
            "parameters": {
                "title": "Parametreler",
                "subtitle": "Katılımcı parametreleri",
                "field_title": "Başlık",
                "team_a": "A Takımı",
                "team_b": "B Takımı",
                "player_a": "Katılımcı A",
                "player_b": "Katılımcı B",
                "points": "Puan",
                "ratio": "Oran",
                "add": "Parametre ekle"
            },
            "questions": {
                "title": "Sorular",
                "subtitle": "Katılımcılar için sorular",
                "question": "Soru",
                "team": "Takım",
                "team_placeholder": "Takım seçin",
                "answers": "Cevaplar",
                "points": "Puan",
                "select_answers": "Cevapları seçin",
                "add_combination": "Kombinasyon ekle",
                "add_question": "Soru ekle"
            },
            "next": "İleri",
            "previous": "Geri",
            "save": "Kaydet"
        },
        "saved": "Senaryo kaydedildi",
        "to_list": "Listeye dön",
        "add_detail": "Senaryo ekle",
        "edit_detail": "Senaryoyu düzenle"
    },
    "notifications": {
        "title": "Bildirimler",
        "mark_unread": "Tümünü okunmadı olarak işaretle",
        "mark_read": "Tümünü okundu olarak işaretle",
        "delete_all": "Tümünü sil",
        "no_new": "Bildirim bulunamadı",
        "system": "Sistem",
        "evaluation": {
            "ready": {
                "subject": "Oturum #:gameNumber Değerlendirmesi",
                "text": "Oturum bir uzman tarafından değerlendirildi"
            }
        },
        "game": {
            "created": {
                "game_assigned": "Size bir oturum atandı",
                "role": "Rol:"
            },
            "proposal": {
                "subject": "Oturum zamanının koordinasyonu",
                "time": "Zaman:",
                "description": "Lütfen onaylayın veya kendi seçeneğinizi önerin"
            },
            "agreed": {
                "subject": "Oturum zamanı üzerinde anlaşıldı",
                "time": "Zaman:",
                "description": "Açıklama ve hazırlık seçenekleri başlangıçtan :preparationTime dakika önce kullanılabilir olacaktır",
                "description_zero": "Artık senaryo açıklamasını inceleyip hazırlanabilirsiniz"
            },
            "preparation": {
                "subject": "Oturuma hazırlık",
                "text": "Oturum hazırlığı kullanılabilir durumda."
            },
            "started": {
                "subject": "Oturum #:gameNumber başladı",
                "text": "Katılın!"
            },
            "missed": {
                "subject": "Oturum #:gameNumber kaçırıldı",
                "text": "Üzgünüz, oturumu kaçırdınız"
            },
            "completed": {
                "subject": "Oturum #:gameNumber tamamlandı",
                "text": "Başarılı oturum"
            },
            "failed": {
                "subject": "Oturum #:gameNumber başarısız oldu",
                "text": "Başarısız şekilde tamamlandı"
            },
            "results": {
                "proposed": {
                    "subject": "Oturum protokolü #:gameNumber üzerinde anlaşıldı",
                    "text": "Anlaşma mevcut"
                },
                "declined": {
                    "subject": "Oturum protokolü #:gameNumber reddedildi",
                    "text": "Teklif reddedildi"
                },
                "not_agreed": {
                    "subject": "Oturum #:gameNumber: taraflar anlaşamadı",
                    "text": "Karşı taraf kaptanı, tarafların anlaşamadığını işaretledi. Oturum başarısız şekilde sona erdi ve sonuçlar sayılmadı."
                }
            },
            "meeting": {
                "ended-player": {
                    "subject": "Oturum Görüşmesi #:gameNumber Sona Erdi",
                    "text": "Lütfen sonuçları bekleyin."
                },
                "ended-captain": {
                    "subject": "Oturum Görüşmesi #:gameNumber Sona Erdi",
                    "text_fill": "Lütfen protokolü doldurun.",
                    "text_wait": "Lütfen protokolün tamamlanmasını bekleyin.",
                    "protocol_time": "Protokol süresi (dakika): :protocolTime"
                }
            }
        }
    },
    "profile": {
        "avatar_allowed": "JPG, GIF veya PNG'ye izin verilir. Maks. boyut 2MB",
        "avatar_label_choose": "Seç",
        "avatar_label_your_avatar": "avatarınız",
        "name": "Ad",
        "last_name": "Soyad",
        "patronymic": "Baba Adı",
        "phone": "Telefon",
        "timezone": "Saat Dilimi",
        "language": "Dil",
        "country": "Ülke",
        "invalid_phone": "Geçersiz telefon numarası",
        "save_changes": "Değişiklikleri kaydet",
        "account": "Hesap",
        "security": "Güvenlik",
        "statistics": "İstatistikler",
        "notifications": "Bildirimler",
        "change_password_title": "Şifreyi değiştir",
        "change_password": "Şifreyi değiştir",
        "current_password": "Mevcut şifre",
        "new_password": "Yeni şifre",
        "confirm_new_password": "Yeni şifreyi onayla",
        "password_requirements": "Şifre Gereksinimleri:",
        "password_requirements_1": "En az 8 karakter uzunluğunda - ne kadar uzun o kadar iyi",
        "password_requirements_2": "En az bir küçük harf",
        "password_requirements_3": "En az bir rakam, sembol veya boşluk karakteri",
        "two_factor_title": "İki Faktörlü Kimlik Doğrulama",
        "two_factor_description": "Hesabınıza ekstra bir güvenlik katmanı ekleyin",
        "two_factor_org_enforced": "İki faktörlü kimlik doğrulama kuruluşunuz tarafından zorunlu kılınmıştır",
        "two_factor_method": "Kimlik Doğrulama Yöntemi",
        "two_factor_disabled": "Devre Dışı",
        "two_factor_email": "E-posta",
        "two_factor_sms": "SMS",
        "two_factor_save": "2FA Ayarlarını Kaydet"
    },
    "auth": {
        "password": "Parola",
        "new_password": "Yeni parola",
        "remember": "Beni hatırla",
        "timezone": "Saat dilimi",
        "forgot": "Parolamı Unuttum",
        "login": "Giriş yap",
        "login_title": "Giriş",
        "new_password_title": "Parolayı değiştir",
        "change_password": "Kaydet",
        "country": "Ülke",
        "invalid_phone": "Geçersiz telefon numarası",
        "privacy_policy_title": "Gizlilik Politikası",
        "privacy_policy_text": "Gizlilik politikası metni...",
        "first_time": "Platformumuzda yeni misiniz?",
        "registration": "Hesap oluştur",
        "forgot_title": "Parolanızı mı unuttunuz?",
        "forgot_description": "E-posta adresinizi girin, size parolanızı sıfırlamak için talimatlar gönderelim",
        "send_reset_link": "Sıfırlama Bağlantısı Gönder ",
        "back_to_login": "Girişe dön",
        "register": "Kayıt Ol",
        "name": "Ad",
        "last_name": "Soyad",
        "patronymic": "Baba adı",
        "phone": "Telefon",
        "enter_password": "Parola Girin",
        "confirm_password": "Parolayı Onayla",
        "not_first_time": "Zaten bir hesabınız var mı?",
        "agree_too": "Kabul ediyorum",
        "privacy_policy": "gizlilik politikası ve şartlar",
        "accept": " Kabul ediyorum ",
        "password_validation": "Alan en az bir büyük harf, bir küçük harf, bir özel karakter ve bir rakam içermeli ve en az 8 karakter uzunluğunda olmalıdır",
        "password_confirm_error": "Parolayı Onayla alanındaki onay eşleşmiyor",
        "set_password": "Yeni Parola Belirle",
        "reset_password": "Parolayı Sıfırla",
        "for": "için",
        "sign_in_to_for": "{org} için {app} uygulamasına giriş",
        "registration_title": "Kayıt",
        "verify_title": "E-posta doğrulama",
        "verify_head": "E-postanızı doğrulayın",
        "verify_description": "Hesap etkinleştirme bağlantısı e-posta adresinize gönderildi. Devam etmek için lütfen bağlantıyı takip edin.",
        "verify_new_link": "Kayıt sırasında belirttiğiniz e-posta adresine yeni bir doğrulama bağlantısı gönderildi.",
        "verify_send": "Doğrulama E-postasını Yeniden Gönder",
        "verify_spam": "Çok fazla istekte bulundunuz, lütfen bir dakika sonra tekrar deneyin",
        "verify_logout": "Çıkış Yap",
        "two_factor_title": "İki Faktörlü Kimlik Doğrulama",
        "two_factor_description_email": "E-posta adresinize bir doğrulama kodu gönderdik. Lütfen kodu aşağıya girin.",
        "two_factor_description_sms": "Telefon numaranıza bir doğrulama kodu gönderdik. Lütfen kodu aşağıya girin.",
        "two_factor_code_label": "Doğrulama Kodu",
        "two_factor_code_placeholder": "6 haneli kodu girin",
        "two_factor_verify": "Doğrula",
        "two_factor_resend": "Kodu Yeniden Gönder",
        "two_factor_resend_success": "Yeni bir kod gönderildi",
        "two_factor_back": "Girişe Dön"
    },
    "filepond": {
        "upload": "Yükle",
        "upload_complete": "Yükleme tamamlandı",
        "uploading": "Yükleniyor",
        "loading": "Yükleniyor",
        "tap_to_cancel": "iptal etmek için dokunun",
        "tap_to_undo": "geri almak için dokunun",
        "upload_aborted": "Yükleme iptal edildi",
        "file_too_large": "Dosya çok büyük"
    },
    "text-editor": {
        "image": "Görselinizi düzenleyiciye sürükleyip bırakmanız yeterlidir"
    },
    "webrtc": {
        "ready_to_start": "Başlamaya hazır",
        "connected": "Bağlandı - Şimdi konuşun!",
        "connection_lost": "Bağlantı kesildi. Lütfen tekrar deneyin."
    },
    "device_settings": {
        "title": "Ses ve Görüntü Cihazı Ayarları",
        "speaker": "Hoparlör/Ses Çıkışı",
        "refresh_devices": "Cihazları Yenile",
        "speaker_switch_unsupported": "Bu tarayıcıda hoparlör değiştirme desteklenmiyor"
    },
    "device_setup": {
        "mic_level": "Mikrofon Seviyesi",
        "mic_on": "Açık",
        "mic_off": "Kapalı",
        "cam_on": "Açık",
        "cam_off": "Kapalı"
    },
    "device_test": {
        "title": "Ses Cihazlarını Test Et",
        "speaker_test": "Hoparlör Testi",
        "speaker_hint": "Seçtiğiniz hoparlörden test sesleri çalmak için düğmeye tıklayın",
        "play_sound": "Test Sesini Çal",
        "playing": "Çalınıyor...",
        "speaker_success": "Ses Çalındı ✓",
        "mic_test": "Mikrofon Testi",
        "mic_hint": "Çalışıp çalışmadığını test etmek için düğmeye tıklayın ve mikrofonunuza konuşun",
        "volume_level": "Ses Düzeyi",
        "speak_now": "Şimdi konuşun...",
        "seconds_short": "sn",
        "start_mic_test": "Mikrofonu Test Et",
        "testing": "Test ediliyor...",
        "test_again": "Tekrar Test Et",
        "mic_success": "Mikrofon düzgün çalışıyor!",
        "mic_fail": "Mikrofon sorunu tespit edildi",
        "mic_fail_hint": "Ses algılanamadı. Lütfen mikrofonunuzun bağlı olduğunu, sessize alınmadığını ve ayarlarda doğru seçildiğini kontrol edin."
    },
    "ai_assistant_types": {
        "type": "Tür",
        "negotiation": "Müzakere",
        "feedback": "Geri Bildirim",
        "ai_profile": "AI Oturumu"
    },
    "Login": "Giriş",
    "UI Elements": "UI Elemanları",
    "Forms & Tables": "Formlar ve Tablolar",
    "Welcome": "Hoş Geldiniz",
    "Pages": "Sayfalar",
    "Charts & Maps": "Grafikler ve Haritalar",
    "Others": "Diğerleri",
    "Typography": "Tipografi",
    "Cards": "Kartlar",
    "Basic": "Temel",
    "Advance": "Gelişmiş",
    "Widgets": "Widget'lar",
    "Components": "Bileşenler",
    "Alert": "Uyarı",
    "Close Alert": "Uyarıyı Kapat",
    "Avatar": "Avatar",
    "Badge": "Rozet",
    "Button": "Düğme",
    "Calendar": "Takvim",
    "Image": "Görsel",
    "Pagination": "Sayfalama",
    "Progress Circular": "Dairesel İlerleme",
    "Progress Linear": "Doğrusal İlerleme",
    "Autocomplete": "Otomatik Tamamlama",
    "Tooltip": "Araç İpucu",
    "Slider": "Kaydırıcı",
    "Date Time Picker": "Tarih Saat Seçici",
    "Select": "Seçim",
    "Switch": "Anahtar",
    "Checkbox": "Onay Kutusu",
    "Radio": "Radyo Düğmesi",
    "Textarea": "Metin Alanı",
    "Rating": "Değerlendirme",
    "File Input": "Dosya Girişi",
    "Otp Input": "OTP Girişi",
    "Form Layout": "Form Düzeni",
    "Form Validation": "Form Doğrulama",
    "Charts": "Grafikler",
    "Apex Chart": "Apex Chart",
    "Chartjs": "Chartjs",
    "Account Settings": "Hesap Ayarları",
    "User Profile": "Kullanıcı Profili",
    "FAQ": "FAQ",
    "Dialog Examples": "İletişim Kutusu Örnekleri",
    "Pricing": "Fiyatlandırma",
    "List": "Liste",
    "Edit": "Düzenle",
    "Nav Levels": "Gezinme Seviyeleri",
    "Level 2.1": "Seviye 2.1",
    "Level 2.2": "Seviye 2.2",
    "Level 3.1": "Seviye 3.1",
    "Level 3.2": "Seviye 3.2",
    "Raise Support": "Destek Talebi Oluştur",
    "Documentation": "Dokümantasyon",
    "Dashboards": "Panolar",
    "Analytics": "Analitik",
    "Apps & Pages": "Uygulamalar ve Sayfalar",
    "Email": "E-posta",
    "Chat": "Sohbet",
    "Invoice": "Fatura",
    "Preview": "Önizleme",
    "Add": "Ekle",
    "User": "Kullanıcı",
    "View": "Görüntüle",
    "Login v1": "Giriş v1",
    "Login v2": "Giriş v2",
    "Register v1": "Kayıt v1",
    "Register v2": "Kayıt v2",
    "Register": "Kayıt Ol",
    "Forget Password v1": "Parolamı Unuttum v1",
    "Forget Password v2": "Şifremi Unuttum v2",
    "Forgot Password v1": "Şifremi Unuttum v1",
    "Forgot Password v2": "Şifremi Unuttum v2",
    "Forgot Password": "Şifremi Unuttum",
    "Reset Password v1": "Şifre Sıfırlama v1",
    "Reset Password v2": "Şifre Sıfırlama v2",
    "Reset Password": "Şifreyi Sıfırla",
    "Miscellaneous": "Diğer",
    "Coming Soon": "Çok Yakında",
    "Not Authorized": "Yetkiniz Yok",
    "Under Maintenance": "Bakımda",
    "Error": "Hata",
    "Statistics": "İstatistikler",
    "Actions": "İşlemler",
    "Access Control": "Erişim Kontrolü",
    "User Interface": "Kullanıcı Arayüzü",
    "CRM": "CRM",
    "eCommerce": "eCommerce",
    "Icons": "Simgeler",
    "Chip": "Chip",
    "Dialog": "İletişim Kutusu",
    "Expansion Panel": "Genişleyen Panel",
    "Combobox": "Combobox",
    "Textfield": "Metin Alanı",
    "Range Slider": "Aralık Kaydırıcısı",
    "Menu": "Menü",
    "Snackbar": "Snackbar",
    "Tabs": "Sekmeler",
    "Form Elements": "Form Elemanları",
    "Form Layouts": "Form Düzenleri",
    "Authentication": "Kimlik Doğrulama",
    "Page Not Found - 404": "Sayfa Bulunamadı - 404",
    "Not Authorized - 401": "Yetkisiz - 401",
    "Server Error - 500": "Sunucu Hatası - 500",
    "2": "2",
    "Forms": "Formlar",
    "Timeline": "Zaman Çizelgesi",
    "Disabled Menu": "Devre Dışı Menü",
    "Help Center": "Yardım Merkezi",
    "Verify Email": "E-postayı Doğrula",
    "Verify Email v1": "E-posta Doğrulama v1",
    "Verify Email v2": "E-postayı Doğrula v2",
    "Two Steps": "İki Adım",
    "Two Steps v1": "İki Adım v1",
    "Two Steps v2": "İki Adım v2",
    "Custom Input": "Özel Giriş",
    "Extensions": "Uzantılar",
    "Tour": "Tur",
    "Register Multi-Steps": "Çok Adımlı Kayıt",
    "Wizard Examples": "Sihirbaz Örnekleri",
    "Checkout": "Ödeme",
    "Create Deal": "Anlaşma Oluştur",
    "Property Listing": "Emlak Listesi",
    "Roles & Permissions": "Roller ve İzinler",
    "Roles": "Roller",
    "Simple Table": "Basit Tablo",
    "Tables": "Tablolar",
    "Data Table": "Veri Tablosu",
    "Permissions": "İzinler",
    "Apps": "Uygulamalar",
    "Misc": "Diğer",
    "Wizard Pages": "Sihirbaz Sayfaları",
    "Form Wizard": "Form Sihirbazı",
    "Numbered": "Numaralandırılmış",
    "3": "3",
    "ecommerce": "e-ticaret",
    "Ecommerce": "Ecommerce",
    "Editors": "Editörler",
    "Front Pages": "Ön Sayfalar",
    "Landing": "Açılış Sayfası",
    "checkout": "ödeme",
    "Payment": "Ödeme",
    "Swiper": "Swiper",
    "Product": "Ürün",
    "Category": "Kategori",
    "Order": "Sipariş",
    "Details": "Detaylar",
    "Customer": "Müşteri",
    "Manage Review": "Değerlendirmeleri Yönet",
    "Referrals": "Yönlendirmeler",
    "Settings": "Ayarlar",
    "Overview": "Genel Bakış",
    "My Course": "Kursum",
    "Course Details": "Kurs Detayları",
    "Academy": "Akademi",
    "Logistics": "Lojistik",
    "Dashboard": "Kontrol Paneli",
    "Fleet": "Fleet",
    "5": "5",
    "10": "10",
    "20": "20",
    "25": "25",
    "50": "50",
    "100": "100",
    "maintenance": "Bakım",
    "maintenance-page": {
        "title": "Bakım Ayarları",
        "notification_section": "Genel Bildirim",
        "notification_placeholder": "Tüm kullanıcılar için bildirim mesajı girin",
        "notification_hint": "Bu mesaj, oturum açmış tüm kullanıcılara uyarı bildirimi olarak gösterilecektir",
        "games_section": "Oturum Engelleme",
        "games_blocked_label": "Yeni oturumları engelle",
        "games_blocked_hint": "Etkinleştirildiğinde kullanıcılar yeni oturum oluşturamaz veya başlatamaz. Mevcut oturumlara yine de yeniden katılınabilir.",
        "save": "Kaydet",
        "clear": "Temizle",
        "clear_confirm": "Bildirimi temizlemek istediğinizden emin misiniz?",
        "last_updated": "Son güncelleme",
        "updated_by": "tarafından",
        "games_blocked_message": "Yaşanan aksaklık için özür dileriz. Platform şu anda bakım çalışması geçiriyor. Oturumlar geçici olarak kullanılamıyor."
    },
    "$vuetify": {
        "badge": "Rozet",
        "noDataText": "Veri mevcut değil",
        "close": "Kapat",
        "open": "aç",
        "carousel": {
            "ariaLabel": {
                "delimiter": "ayırıcı"
            }
        },
        "dataFooter": {
            "itemsPerPageText": "Sayfa başına öğe:",
            "itemsPerPageAll": "Tümü",
            "pageText": "{2} içinden {0}-{1}",
            "firstPage": "İlk Sayfa",
            "prevPage": "Önceki Sayfa",
            "nextPage": "Sonraki Sayfa",
            "lastPage": "Son Sayfa"
        },
        "pagination": {
            "ariaLabel": {
                "root": "kök",
                "previous": "önceki",
                "next": "sonraki",
                "first": "ilk",
                "last": "son",
                "currentPage": "mevcutSayfa",
                "page": "sayfa"
            }
        },
        "input": {
            "clear": "temizle",
            "appendAction": "ekEylemi",
            "prependAction": "önEylemi",
            "counterSize": "sayaçBoyutu",
            "otp": "otp"
        },
        "fileInput": {
            "counterSize": "sayaçBoyutu"
        },
        "rating": {
            "ariaLabel": {
                "item": "öğe"
            }
        }
    },
    "subscription-plans": "Abonelik Planları",
    "organization-subscriptions": "Organizasyon Abonelikleri",
    "subscription-plans-page": {
        "name": "Ad",
        "description": "Açıklama",
        "period": "Dönem",
        "grace_days": "Ek Süre (Gün)",
        "features": "Özellikler",
        "charges": "Kontenjan",
        "actions": " ",
        "add": "Plan Ekle",
        "add_popup": "Plan Ekle",
        "edit": "Planı Düzenle",
        "edit_popup": "Planı Düzenle",
        "delete": "Planı Sil",
        "delete_confirm": "Bu planı silmek istediğinizden emin misiniz?",
        "monthly": "Aylık",
        "yearly": "Yıllık",
        "permanent": "Kalıcı",
        "regular_games": "Normal Oturumlar",
        "ai_games": "AI Oturumları",
        "any_games": "Tüm Oturumlar",
        "ai_chat_messages": "AI Sohbet Mesajları",
        "organization": "Kuruluş",
        "global_plan": "Genel",
        "periodicity": "Periyot",
        "min_zero": ">= 0 olmalı",
        "min_one": ">= 1 olmalı"
    },
    "organization-subscriptions-page": {
        "organization": "Organizasyon",
        "host": "Alan Adı",
        "current_plan": "Mevcut Plan",
        "status": "Durum",
        "expires_at": "Bitiş Tarihi",
        "actions": " ",
        "assign_plan": "Plan Ata",
        "switch_plan": "Planı Değiştir",
        "cancel_subscription": "Aboneliği İptal Et",
        "renew_subscription": "Aboneliği Yenile",
        "cancel_confirm": "Bu aboneliği iptal etmek istediğinizden emin misiniz?",
        "renew_confirm": "Bu aboneliği yenilemek istediğinizden emin misiniz?",
        "no_plan": "Plan yok",
        "active": "Aktif",
        "cancelled": "İptal Edildi",
        "expired": "Süresi Doldu",
        "immediately": "Hemen değiştir",
        "view_usage": "Kullanımı Görüntüle",
        "usage": "Kullanım",
        "used_of": "{limit} üzerinden {used}",
        "add_ticket": "Bilet Ekle",
        "initial_consumption": "Başlangıç Tüketimi",
        "feature": "Özellik",
        "charges": "Ücretler",
        "expired_at_optional": "Bitiş Tarihi (isteğe bağlı)",
        "active_tickets": "Aktif Biletler",
        "no_expiry": "Süresiz",
        "tickets_only": "Biletler",
        "revoke_ticket": "İptal Et",
        "revoke_ticket_confirm": "Bu bileti iptal etmek istediğinizden emin misiniz?",
        "deduct": "Düş",
        "deduct_amount": "Miktar",
        "deduct_confirm": "Kullanımı düş"
    },
    "api-tokens": "API Token'ları",
    "api-tokens-page": {
        "select_user": "Kullanıcı",
        "select_user_hint": "API token'larını görüntülemek ve yönetmek için bir kullanıcı seçin.",
        "no_users_found": "Kullanıcı bulunamadı",
        "no_tokens": "Bu kullanıcının API token'ı yok.",
        "token_name": "Ad",
        "abilities": "Yetkiler",
        "ability": "Yetki",
        "created_at": "Oluşturulma Tarihi",
        "last_used_at": "Son Kullanım Tarihi",
        "expires_at": "Bitiş Tarihi",
        "actions": " ",
        "issue_token": "Token Oluştur",
        "issue": "Oluştur",
        "issue_failed": "Token oluşturulamadı",
        "token": "Token",
        "plaintext_warning": "Bu token'ı şimdi kopyalayın — bir daha gösterilmeyecektir.",
        "revoke": "İptal Et",
        "revoke_confirm": "Bu token'ı iptal etmek istediğinizden emin misiniz? Bunu kullanan entegrasyonlar çalışmayı durduracaktır."
    },
    "subscription": {
        "current_plan": "Mevcut Plan",
        "expires_at": "Sona erme: {date}",
        "no_active_plan": "Aktif abonelik planı yok",
        "quota_warning": "Kalan kota az",
        "regular_games": "Normal Oturumlar",
        "ai_games": "AI Oturumları",
        "any_games": "Herhangi Bir Oturum",
        "ai_chat_messages": "AI Sohbet Mesajları",
        "used_of": "{limit} üzerinden {used}",
        "remaining": "{count} kaldı",
        "quota_exceeded": "Özellik kotası aşıldı",
        "tickets_only": "Kredi Paketleri",
        "session_package": "Oturum paketi",
        "games_available": "Oturumlar",
        "users": "Kullanıcılar",
        "active_users": "Aktif Kullanıcılar",
        "active_tickets": "Kredi Paketleri",
        "ticket_charges": "{charges} kredi",
        "ticket_no_expiry": "Süresiz",
        "unlimited": "Sınırsız",
        "no_game_limits": "Oturum sayısında kısıtlama yok"
    },
    "knowledge-base-page": {
        "title": "Bilgi Tabanı",
        "upload": "Belge Yükle",
        "search-placeholder": "Başlığa göre ara...",
        "filter-status": "Durum",
        "confirm-delete": "Bu belgeyi silmek istediğinizden emin misiniz? İlgili tüm parçalar kaldırılacaktır.",
        "no-documents": "Kullanılabilir belge yok",
        "status": {
            "processing": "İşleniyor",
            "ready": "Hazır",
            "failed": "Hata"
        },
        "headers": {
            "title": "Başlık",
            "type": "Tür",
            "size": "Boyut",
            "chunks": "Parçalar",
            "status": "Durum",
            "created": "Yükleme Tarihi",
            "actions": "İşlemler"
        },
        "upload-dialog": {
            "title": "Belge Yükle",
            "name": "Başlık",
            "file": "Dosya",
            "hint": "PDF, DOCX, TXT, CSV, XLSX (maks. 10 MB)",
            "submit": "Yükle"
        },
        "retry-success": "Belge yeniden işlenmek üzere gönderildi",
        "delete-success": "Belge silindi",
        "upload-success": "Belge yüklendi",
        "provider-unsupported": "Bilgi tabanı, kuruluşunuzun mevcut AI sağlayıcısıyla kullanılamıyor."
    },
    "candidate-page": {
        "document_title": "Mülakat",
        "greeting": "Merhaba, {name}!",
        "intro_lead": "{organization} sizi «{vacancy}» pozisyonu için sanal bir görüşmeciyle yapılacak mülakata davet ediyor.",
        "duration": "Mülakat yaklaşık {minutes} dakika sürecek.",
        "requirements_title": "Nelere ihtiyacınız olacak",
        "requirement_mic": "Çalışan bir mikrofon, tercihen mikrofonlu kulaklık",
        "requirement_camera_required": "Açık bir kamera: bu mülakat için zorunludur",
        "requirement_camera_optional": "Kamera zorunlu değildir, ancak görüşme onunla daha doğal geçer",
        "requirement_browser": "Bilgisayar ve güncel bir Chrome, Edge veya Safari tarayıcısı",
        "requirement_network": "Kararlı bir internet bağlantısı ve kimsenin sizi rahatsız etmeyeceği sessiz bir ortam",
        "continue": "Devam et",
        "consent": {
            "accept": "Metni okudum ve kişisel verilerimin işlenmesine onay veriyorum",
            "back": "Geri",
            "start": "Mülakatı başlat"
        },
        "terminal": {
            "finished": {
                "title": "Teşekkürler!",
                "text": "Mülakat tamamlandı, sonuç işe alım uzmanına iletildi — sizinle iletişime geçecektir. Bu sayfayı kapatabilirsiniz."
            },
            "already_completed": {
                "title": "Mülakat zaten tamamlandı",
                "text": "Bu bağlantı üzerinden mülakat zaten tamamlandı. Tekrar almanız gerekiyorsa işe alım uzmanıyla iletişime geçin."
            },
            "not_found": {
                "title": "Bağlantı bulunamadı",
                "text": "Adreste bir yazım hatası olabilir veya bağlantının süresi dolmuş olabilir. İşe alım uzmanından gelen e-postayı kontrol edin ya da onunla iletişime geçin."
            },
            "session_conflict": {
                "title": "Başka bir hesapla oturum açtınız",
                "text": "Mevcut hesaptan çıkış yapın veya bağlantıyı tarayıcınızın gizli penceresinde açın."
            },
            "link_revoked": {
                "title": "Bu bağlantıya erişim kapatıldı",
                "text": "İşe alım uzmanı bu bağlantıyı iptal etti. Yeni bir bağlantı almak için onunla iletişime geçin."
            },
            "link_expired": {
                "title": "Bağlantının süresi doldu",
                "text": "Yeni bir bağlantı almak için işe alım uzmanıyla iletişime geçin."
            },
            "attempts_exhausted": {
                "title": "Deneme hakkı kalmadı",
                "text": "Bu bağlantı için kullanılabilecek tüm denemeler kullanıldı. İşe alım uzmanıyla iletişime geçin."
            },
            "unavailable": {
                "title": "Şu anda başlatılamıyor",
                "text": "Daha sonra tekrar deneyin veya işe alım uzmanıyla iletişime geçin."
            },
            "rate_limited": {
                "title": "Çok fazla deneme",
                "text": "Bir dakika bekleyip sayfayı yenileyin."
            },
            "aborted": {
                "title": "Mülakat başlamadı",
                "text": "Sayfayı yenileyip tekrar deneyin. Sorun devam ederse işe alım uzmanıyla iletişime geçin."
            },
            "generic": {
                "title": "Bir şeyler ters gitti",
                "text": "Sayfayı yenileyip tekrar deneyin. Sorun devam ederse işe alım uzmanıyla iletişime geçin."
            }
        }
    },
    "recruiting-page": {
        "title": "İşe alım",
        "create": "Yeni pozisyon",
        "edit": "Pozisyonu düzenle",
        "empty": "Henüz pozisyon yok",
        "load_error": "Pozisyon listesi yüklenemedi",
        "retry": "Yeniden dene",
        "back": "Pozisyonlara dön",
        "open": "Adaylar",
        "archive": "Arşivle",
        "no_expiry": "Süresiz",
        "confirm_archive": "Pozisyon arşive gönderilsin mi? Bu pozisyon için artık yeni bağlantı verilemeyecek.",
        "headers": {
            "title": "Pozisyon",
            "scenario": "Senaryo",
            "status": "Durum",
            "expires_at": "Bitiş Tarihi",
            "actions": "İşlemler"
        },
        "status": {
            "draft": "Taslak",
            "active": "Aktif",
            "archived": "Arşivlendi"
        },
        "dialog": {
            "title_label": "Pozisyon başlığı",
            "scenario_label": "Mülakat senaryosu",
            "scenario_placeholder": "AI ile oynanacak senaryoyu seçin",
            "scenario_hint": "Listede yalnızca AI'ya karşı oyuna uygun senaryolar bulunur",
            "status_label": "Durum",
            "expires_label": "Bitiş Tarihi",
            "expires_hint": "Boş bırakılırsa pozisyon süresiz olur",
            "save": "Kaydet",
            "cancel": "İptal"
        },
        "messages": {
            "created": "Pozisyon oluşturuldu",
            "updated": "Pozisyon güncellendi",
            "archived": "Pozisyon arşivlendi",
            "revoked": "Bağlantı iptal edildi",
            "attempt_granted": "Adaya bir deneme hakkı daha verildi",
            "copied": "Bağlantı kopyalandı",
            "error": "Bir şeyler ters gitti"
        },
        "candidates": {
            "title": "Adaylar",
            "empty": "Bu pozisyon için henüz bağlantı verilmedi",
            "load_error": "Aday listesi yüklenemedi",
            "issue": "Bağlantı ver",
            "import": "Dosyadan içe aktar",
            "expired": "Süresi doldu",
            "no_games": "Mülakat başlamadı",
            "attempts": "{used} / {allowed}",
            "revoke": "Bağlantıyı iptal et",
            "extra_attempt": "Bir deneme daha ver",
            "open_result": "Mülakat sonucunu aç",
            "confirm_revoke": "Adayın bağlantısı iptal edilsin mi? Devam eden bir mülakat dahil, erişim hemen kapanır.",
            "confirm_extra_attempt": "Adaya bir deneme hakkı daha verilsin mi?",
            "headers": {
                "candidate": "Aday",
                "link_status": "Bağlantı",
                "invite": "Davet",
                "game_status": "Mülakat",
                "attempts": "Denemeler",
                "expires_at": "Bağlantı Bitiş Tarihi",
                "actions": "İşlemler"
            },
            "link_status": {
                "created": "Verildi",
                "opened": "Açıldı",
                "in_progress": "Mülakat devam ediyor",
                "completed": "Mülakat tamamlandı",
                "revoked": "İptal edildi"
            },
            "invite_status": {
                "not_sent": "Gönderilmedi",
                "queued": "Sırada",
                "sent": "Gönderildi",
                "failed": "Gönderilemedi"
            },
            "invite_sent_at": "E-posta hizmeti iletiyi {date} tarihinde kabul etti",
            "invite_failure": {
                "rejected": "E-posta hizmeti iletiyi reddetti — bağlantıyı adaya kendiniz gönderin",
                "transport": "Gönderim başarısız oldu — bağlantıyı adaya kendiniz gönderin",
                "revoked": "Bağlantı iptal edildi",
                "sending_disabled": "E-posta gönderimi kapalı",
                "blocked": "Adres engel listesinde — bağlantıyı adaya kendiniz gönderin"
            }
        },
        "issue_dialog": {
            "title": "Kişisel bağlantı ver",
            "name": "Ad",
            "last_name": "Soyad",
            "email": "E-posta",
            "phone": "Telefon",
            "attempts": "Deneme sayısı",
            "expires_at": "Bağlantı Bitiş Tarihi",
            "expires_hint": "Boş bırakılırsa pozisyonun bitiş tarihi kullanılır",
            "submit": "Bağlantı ver",
            "close": "Kapat",
            "result_title": "Bağlantı verildi",
            "warning": "Bağlantıyı şimdi kopyalayın — yalnızca bir kez gösterilir. Veritabanında yalnızca onun hash'i saklanır, bu yüzden bağlantı geri getirilemez: kaybedilen bağlantı iptal edilip yeniden verilmelidir.",
            "copy": "Kopyala",
            "copied": "Kopyalandı",
            "send_invite": "{email} adresine davet gönder",
            "send_invite_no_email": "E-posta ile davet gönder",
            "send_invite_blocked": "Bu adres engel listesinde — e-posta gönderilmeyecek",
            "invite_queued": "Davet sıraya alındı: {email}",
            "invite_blocked": "Davet gönderilmedi: {email} engel listesinde. Bağlantıyı adaya kendiniz gönderin"
        },
        "import_dialog": {
            "title": "Adayları içe aktar",
            "subtitle": "Dosyadaki her satır bir aday ve bir kişisel bağlantı anlamına gelir.",
            "file": "Aday listesi dosyası",
            "columns": "Sütunlar: Ad, Soyad, E-posta, Telefon",
            "limits": "xlsx veya ';' ayraçlı CSV, en fazla 200 satır ve 10 MB",
            "size_error": "Dosya 10 MB'den büyük",
            "download_example": "Şablonu indir",
            "note_title": "Bağlantılar yalnızca indirilen dosyada görünür",
            "note_text": "Dosya, içe aktarma tamamlanır tamamlanmaz indirilir. Veritabanında yalnızca bağlantıların hash'i saklanır, bu yüzden bağlantıları ikinci kez dışa aktarmak mümkün değildir — dosyayı saklayın.",
            "submit": "İçe aktar",
            "cancel": "İptal",
            "result_title": "Bağlantılar verildi",
            "result": "Verilen bağlantı sayısı: {count}. Dosya indirildi.",
            "invites_blocked": "Gönderilmeyen davet sayısı: {count}. Bu adresler engel listesinde — bağlantıları bu adaylara kendiniz gönderin.",
            "saved_title": "İndirilen dosyayı saklayın",
            "saved_text": "Bu dosya, bu bağlantıların tek kopyasıdır: veritabanında yalnızca onların hash'i saklanır. Kaybedilen bir bağlantı yalnızca iptal edilip yeniden verilebilir.",
            "download_again": "Dosyayı tekrar indir",
            "errors_title": "Reddedilen satırlar",
            "error_row": "Satır {row}: {error}",
            "errors_truncated": "…ve {count} satır daha reddedildi. İlk 50 tanesi yukarıda listelenir.",
            "send_invites": "Adaylara e-posta ile davet gönder",
            "send_invites_hint": "E-posta adresi olmayan adaylara davet gönderilmez"
        }
    },
    "ai-reports": "AI raporları",
    "ai-reports-page": {
        "title": "AI raporları",
        "subtitle": "Raporu kendi cümlelerinizle anlatın — tanımını oluşturur, önizlemesini gösterir ve Excel'e aktarırız.",
        "status": {
            "draft": "Taslak",
            "pending": "Oluşturuluyor",
            "ready": "Hazır",
            "failed": "Oluşturulamadı"
        },
        "list": {
            "title": "Raporlarım",
            "new": "Yeni rapor",
            "empty": "Henüz rapor yok. “Yeni rapor”a tıklayın ve neyi göstermek istediğinizi anlatın.",
            "untitled": "Adsız",
            "delete": "Raporu sil",
            "delete_confirm": "Rapor, oluşturulan dosyasıyla birlikte silinsin mi?",
            "deleted": "Rapor silindi"
        },
        "dialog": {
            "title": "Diyalog",
            "open_dictionary": "Veri sözlüğü",
            "placeholder": "Örneğin: geçen çeyrekte her departman kaç oyun gerçekleştirdi",
            "send": "Gönder",
            "empty_title": "Rapor neyi göstermeli?",
            "empty_text": "Sıradan cümlelerle yazın: hangi veriler, hangi dönem için ve hangi kırılımda. Bir şey eksikse tekrar sorarım.",
            "examples_title": "Örneğin:",
            "examples": {
                "e1": "Geçen çeyrekte her departman kaç oyun gerçekleştirdi",
                "e2": "2026 yılında satış departmanındaki ortalama yetkinlik puanı",
                "e3": "Bir aydan uzun süredir oyun oynamayan çalışanlar",
                "e4": "Son 30 gündeki pozisyonlara göre adaylar ve bağlantı durumları"
            },
            "thinking": "Rapor oluşturuluyor…",
            "waiting_hint": "Yanıt burada kendiliğinden görünecek — sayfayı yenilemeye gerek yok.",
            "retry": "Tekrar dene",
            "dismiss": "Gizle",
            "spec_ready": "Rapor hazırlandı — aşağıdaki önizlemeyi kontrol edin ve dosyayı oluşturun.",
            "stuck_title": "Görünüşe göre bir döngüye girdik",
            "stuck_text": "Veri sözlüğüne bakın ve isteği oradaki ifadelerle yeniden yazın — bu, başka bir açıklayıcı soruyu yanıtlamaktan daha hızlıdır.",
            "rejected_title": "Bu rapor henüz oluşturulamıyor",
            "reason": {
                "no_such_measure": "Bu ölçüt verilerimizde yok. Sözlükteki ölçüt listesine bakın.",
                "no_such_field": "Bu alan verilerimizde yok. Sözlükteki alan listesine bakın.",
                "cross_dataset": "İstek, aynı anda iki veri kümesinden veri gerektiriyor. Bunu iki rapora bölün.",
                "window_function": "Toplamdan pay alma, sıralamadaki konum ve önceki dönemle karşılaştırma henüz desteklenmiyor.",
                "other": "İstek, mevcut verilerin dışına çıkıyor. Sözlüğe bakın ve farklı bir ifade deneyin."
            },
            "usage": {
                "employees": "çalışan yok | {n} çalışan | {n} çalışan",
                "games": "oyun yok | {n} oyun | {n} oyun",
                "scenarios": "senaryo yok | {n} senaryo | {n} senaryo",
                "evaluations": "değerlendirme yok | {n} değerlendirme | {n} değerlendirme",
                "candidates": "aday yok | {n} aday | {n} aday"
            },
            "option_created_at": "{date} tarihinde eklendi"
        },
        "preview": {
            "title": "Önizleme",
            "no_report": "Soldan bir rapor seçin veya yeni bir rapor başlatın.",
            "no_spec": "Raporu diyalogda anlatın — istek anlaşılır anlaşılmaz önizleme görünür.",
            "spec_title": "Raporda neler olacak",
            "rows_hint": "İlk {count} satır gösteriliyor",
            "total": "Toplam satır: {count}",
            "zero_rows": "Bu istek hiç satır döndürmüyor. Dönemi genişletin veya filtreleri kaldırın — boş bir dosya oluşturmanın anlamı yok.",
            "zero_rows_hint": "Filtre değerlerini kontrol edin — bunlar için veri olmayabilir",
            "duplicate_rows": "Önizlemedeki bazı satırlar aynı: seçilen sütunlar bu veri kümesinin kayıtlarını birbirinden ayırmıyor. Burada bir satırın gerçekte ne anlama geldiğini kontrol edin — ayırt edici bir sütun eksik olabilir.",
            "too_many_rows": "Raporda {count} satır var, üst sınır {max}. Dönemi daraltın veya filtre ekleyin: üst sınır aşıldığında dosya kısaltılmaz, hiç oluşturulmaz.",
            "generate": "Dosyayı oluştur",
            "regenerate": "Yeniden oluştur",
            "queued": "Dosya oluşturuluyor — hazır olduğunda kart kendiliğinden güncellenir.",
            "failed": "Rapor oluşturulamadı",
            "download": ".xlsx indir",
            "downloads": "İndirme sayısı: {count}",
            "ttl_warning": "Dosya {days} gün saklanır, ardından silinir — hemen indirin.",
            "expires_at": "{date} tarihine kadar kullanılabilir",
            "expired": "Dosya saklama süresi dolduğunda silindi — raporu yeniden oluşturun."
        },
        "spec": {
            "dataset": "Veri",
            "columns": "Sütunlar",
            "measures": "Ölçütler",
            "group_by": "Kırılım",
            "period": "Dönem",
            "period_value": "{field}: {from} – {to}",
            "period_all": "Tüm kullanılabilir dönem",
            "filters": "Filtreler",
            "having": "Ölçüt koşulları",
            "sort": "Sıralama",
            "limit": "Satır sınırı",
            "limit_value": "ilk {count} satır",
            "granularity": {
                "year": "yıla göre",
                "quarter": "çeyreğe göre",
                "month": "aya göre",
                "week": "haftaya göre",
                "day": "güne göre",
                "dow": "haftanın gününe göre"
            },
            "dir": {
                "asc": "artan",
                "desc": "azalan"
            },
            "filter": {
                "equals": "{field} — {value}",
                "not_equals": "{field} — {value} değil",
                "in": "{field} — şunlardan biri: {value}",
                "not_in": "{field} — şunlar hariç: {value}",
                "gt": "{field}, {value} değerinden büyük",
                "gte": "{field}, en az {value}",
                "lt": "{field}, {value} değerinden küçük",
                "lte": "{field}, en fazla {value}",
                "contains": "{field}, “{value}” içeriyor",
                "between": "{field} — {from} ile {to} arası",
                "is_null": "{field} doldurulmamış",
                "is_not_null": "{field} doldurulmuş"
            }
        },
        "value": {
            "yes": "Evet",
            "no": "Hayır"
        },
        "dictionary": {
            "title": "Veri sözlüğü",
            "subtitle": "Bir rapora eklenebilecek her şey. Liste canlıdır: tanımın oluşturulduğu liste ile aynıdır.",
            "fields": "Alanlar",
            "measures": "Ölçütler",
            "values": "Değerler",
            "show_values": "Kuruluşunuzun değerlerini göster",
            "hide_values": "Değerleri gizle",
            "values_error": "Değerler yüklenemedi — tekrar deneyin.",
            "values_empty": "Kuruluşunuzda bu alan için henüz değer yok.",
            "limits": {
                "title": "Rapor neyi yapamaz",
                "pivot": "Her katılımcı veya her soru için bir sütun içeren özet tablo oluşturulmaz. Bunun yerine uzun biçimi isteyin: her katılımcı-soru çifti için bir satır.",
                "window": "Rapor aydan aya değişimi, toplamdaki payı, sıralamadaki yeri ve “her departmandaki en iyi üçü” hesaplamaz. Aylık kırılımı alın, gerisini Excel'de tamamlayın.",
                "missing": "Sistemin saklamadığı hiçbir şey raporda görünmez: maaşlar, NPS ve başka sistemlerde tutulan diğer veriler hiçbir ad altında görünmez."
            },
            "empty": "Sözlük boş — yöneticinizle iletişime geçin.",
            "close": "Kapat"
        },
        "errors": {
            "generic": "Bir şeyler yanlış gitti. Lütfen tekrar deneyin.",
            "detail": "Anlaşılmadı: {value}",
            "rate_limit": "Çok fazla istek. Bir dakika bekleyip tekrar deneyin.",
            "download": "Dosya indirilemedi.",
            "turn_failed": "Yanıt alınamadı. İsteği tekrar gönderin.",
            "turn_stuck_in_queue": "İstek işleme alınamadı — kuyrukta çok uzun süre bekledi. İsteği tekrar gönderin.",
            "unknown_resolution": "Bu seçenek geçerliliğini yitirdi — rapor bu sırada değişti. Raporu yeniden açıp isteğinizi netleştirin."
        }
    },
    "externalLaunch": {
        "document_title": "Pratik oturumu",
        "intro": {
            "title": "Pratik konuşması",
            "lead": "Az sonra sanal bir muhatapla konuşacaksınız. Konuşma kaydedilir ve değerlendirilir, sonuç öğrenme sisteminize geri döner.",
            "requirements_title": "İhtiyacınız olanlar",
            "requirement_mic": "Çalışan bir mikrofon, tercihen kulaklık",
            "requirement_camera": "Kamera zorunlu değildir, ancak konuşma onunla daha doğal geçer",
            "requirement_browser": "Güncel Chrome, Edge veya Safari yüklü bir bilgisayar",
            "requirement_network": "Kararlı bir bağlantı ve sizi kimsenin bölmeyeceği sessiz bir ortam",
            "start": "Başlat"
        },
        "relaunch_hint": "Öğrenme sisteminize dönün ve materyali yeniden açın.",
        "saving": "Sonuç kaydediliyor…",
        "review": {
            "document_title": "Oturum incelemesi",
            "attempt": "{number}. deneme",
            "result": {
                "passed": "Geçti",
                "failed": "Geçmedi",
                "pending": "Henüz değerlendirilmedi"
            },
            "score_of_100": "100 üzerinden {score}",
            "threshold": "Geçme eşiği: {threshold}",
            "skills_title": "Yetkinlikler ve öneriler",
            "skills_empty": "Bu deneme için henüz yetkinlik bazında geri bildirim yok.",
            "comments_title": "Kayıt hakkında yorumlar",
            "comments_empty": "Bu kayıt için yorum yok.",
            "loading": "İnceleme yükleniyor",
            "error": {
                "not_found": {
                    "title": "Bağlantı çalışmıyor",
                    "text": "İnceleme artık kullanılamıyor: bağlantının süresi doldu veya deneme iptal edildi."
                },
                "expired": {
                    "title": "Sayfanın süresi doldu",
                    "text": "İncelemeyi öğrenme sistemindeki bağlantıdan yeniden açın."
                },
                "generic": {
                    "title": "İnceleme gösterilemiyor",
                    "text": "Bizim tarafımızda bir şeyler ters gitti. Bağlantıyı yeniden açmayı deneyin."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Teşekkürler!",
                "text": "Konuşma sona erdi. Değerlendirme hazır olduğunda sonuç öğrenme sisteminizde görünecek. Bu sayfayı kapatabilirsiniz."
            },
            "aborted": {
                "title": "Konuşma başlamadı",
                "text": "Konuşma başlamadan önce bir şeyler ters gitti."
            },
            "token_expired": {
                "title": "Oturumun süresi doldu",
                "text": "Bu konuşmaya erişim artık geçerli değil."
            },
            "not_found": {
                "title": "Bağlantı çalışmıyor",
                "text": "Adreste bir yazım hatası olabilir veya bağlantının süresi dolmuş olabilir."
            },
            "rate_limited": {
                "title": "Çok fazla deneme",
                "text": "Yeniden denemeden önce bir dakika bekleyin."
            },
            "generic": {
                "title": "Şu anda başlatılamıyor",
                "text": "Bizim tarafımızda bir şeyler ters gitti."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Materyal kapalı",
                "text": "Bu materyal artık pratik için kullanılamıyor."
            },
            "publication_draft": {
                "title": "Materyal henüz yayınlanmadı",
                "text": "Bu materyal için pratik henüz açılmadı."
            },
            "publication_expired": {
                "title": "Materyalin süresi doldu",
                "text": "Bu materyalle pratik yapılabilecek süre sona erdi."
            },
            "feature_disabled": {
                "title": "Materyal kapalı",
                "text": "Öğrenme sisteminden pratik yapma, kuruluşunuz için kapatılmış."
            },
            "connection_disabled": {
                "title": "Materyal kapalı",
                "text": "Öğrenme sisteminizle bağlantı kapatılmış. Kursu atayan kişiyle iletişime geçin."
            },
            "launch_limit_reached": {
                "title": "Sınıra ulaşıldı",
                "text": "Bu materyal için izin verilen maksimum konuşma sayısına ulaşıldı."
            },
            "daily_budget_exhausted": {
                "title": "Bugünlük bu kadar",
                "text": "Günlük izin verilen konuşma sayısına ulaştınız. Yarın tekrar deneyin."
            },
            "attempts_exhausted": {
                "title": "Deneme hakkınız kalmadı",
                "text": "Bu materyal için izin verilen tüm denemeleri kullandınız."
            },
            "quota_exhausted": {
                "title": "Şu anda başlatılamıyor",
                "text": "Kuruluşunuzun kalan konuşma hakkı yok. Kursu atayan kişiyle iletişime geçin."
            },
            "user_limit_reached": {
                "title": "Şu anda başlatılamıyor",
                "text": "Kuruluşunuzda boş koltuk kalmadı. Kursu atayan kişiyle iletişime geçin."
            },
            "scenario_unavailable": {
                "title": "Materyal kullanılamıyor",
                "text": "Bu materyalin arkasındaki konuşma artık mevcut değil."
            },
            "assignment_check_unavailable": {
                "title": "Şu anda başlatılamıyor",
                "text": "Bu materyalin size atandığını doğrulayamadık. Kursu atayan kişiyle iletişime geçin."
            },
            "code_invalid": {
                "title": "Bağlantının süresi doldu",
                "text": "Bu bağlantı zaten kullanılmış veya süresi dolmuş."
            },
            "channel_verification_failed": {
                "title": "Öğrenme sistemi yanıt vermedi",
                "text": "İsteği öğrenme sisteminizde doğrulayamadık."
            },
            "external_system_unavailable": {
                "title": "Öğrenme sistemi yanıt vermiyor",
                "text": "Kursunuzun atamasını öğrenme sisteminde doğrulayamadık. Birkaç dakika sonra tekrar deneyin."
            },
            "user_not_found": {
                "title": "Sizi tanımlayamadık",
                "text": "Burada sizin için bir hesap yok ve kuruluşunuz hesapları otomatik olarak oluşturmuyor. Kursu atayan kişiyle iletişime geçin."
            },
            "user_unavailable": {
                "title": "Hesabınız devre dışı",
                "text": "Kursu atayan kişiyle iletişime geçin."
            },
            "user_deleted": {
                "title": "Hesabınız silindi",
                "text": "Kursu atayan kişiyle iletişime geçin."
            },
            "email_taken_linking_disabled": {
                "title": "Sizi tanımlayamadık",
                "text": "E-posta adresiniz zaten başka bir hesaba ait. Kursu atayan kişiyle iletişime geçin."
            },
            "service_role_not_allowed": {
                "title": "Bu hesapla pratik yapılamaz",
                "text": "Yönetici hesapları pratik konuşmalara katılamaz. Kendi öğrenci hesabınızla giriş yapın."
            },
            "unverified_request": {
                "title": "İsteği doğrulayamadık",
                "text": "Öğrenme sisteminiz bu konuşmanın hesabınızdan başlatıldığını doğrulamadı."
            }
        },
        "manage": {
            "nav": {
                "group": "Dış başlatma",
                "publications": "Yayınlar",
                "connections": "LMS bağlantıları"
            },
            "messages": {
                "error": "Bir şeyler ters gitti. Yeniden deneyin.",
                "load_error": "Veriler yüklenemedi."
            },
            "connections": {
                "title": "Öğrenme sistemi bağlantıları",
                "subtitle": "Bu kuruluşun pratik başlattığı öğrenme sistemi hesapları.",
                "create": "Bağlantı ekle",
                "edit": "Düzenle",
                "set_credentials": "Kimlik bilgilerini ayarla",
                "empty": "Henüz bağlantı yok.",
                "secret_missing": "Ayarlanmadı",
                "no_expiry": "Süresiz",
                "headers": {
                    "account": "Hesap",
                    "base_url": "Adres",
                    "client_id": "İstemci Kimliği",
                    "secret": "Gizli Anahtar",
                    "status": "Durum",
                    "expires_at": "Kimlik Bilgisi Bitiş Tarihi",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Kimlik bilgisi yok",
                    "active": "Aktif",
                    "expired": "Kimlik bilgilerinin süresi doldu",
                    "disabled": "Devre dışı"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Yeni bağlantı",
                    "edit_title": "Bağlantı",
                    "immutable_hint": "Öğrenme sistemi ve hesap değiştirilemez: bunlar öğrenci kimlik alanını tanımlar. Farklı bir hesap yeni bir bağlantı demektir.",
                    "lms_label": "Öğrenme sistemi",
                    "account_key_label": "Hesap",
                    "account_key_hint": "Öğrenme sistemindeki hesap tanımlayıcısı.",
                    "base_url_label": "iSpring REST API adresi",
                    "base_url_hint": "Örneğin: https://api-learn.ispringlearn.ru. Bu, şirket portalınızın adresi değil: gizli anahtar buraya gönderilir.",
                    "base_url_https": "Adres https:// ile başlamalıdır",
                    "enabled_label": "Bağlantı açık",
                    "enabled_hint": "Bağlantı hiçbir zaman silinmez — kapatılır. Yayınlar ve başlatmalar listelerde kalır, ancak yeni başlatmalar reddedilir ve sonuçlar artık öğrenme sistemine gitmez.",
                    "credentials_optional": "Kimlik bilgileri isteğe bağlıdır. Bunlar olmadan bağlantı kısıtlı modda çalışır.",
                    "client_id_label": "İstemci Kimliği",
                    "secret_label": "Gizli Anahtar",
                    "secret_hint": "Şifrelenmiş olarak saklanır. Bir daha geri okunamaz — yalnızca son dört karakteri gösterilir.",
                    "expires_at_label": "Kimlik bilgisi bitiş tarihi",
                    "expires_at_hint": "Kimlik bilgilerinin süresi dolmuyorsa boş bırakın."
                },
                "credentials_dialog": {
                    "title": "Kimlik bilgileri",
                    "lead": "Yeni gizli anahtar öncekinin yerini alır. Bağlantı kimliğini korur, öğrenci bağlantıları ve başlatmalar olduğu yerde kalır.",
                    "secret_hint": "Önceki gizli anahtara gerek yoktur ve bir daha geri okunamaz."
                },
                "messages": {
                    "saved": "Bağlantı kaydedildi",
                    "credentials_saved": "Kimlik bilgileri kaydedildi"
                }
            },
            "publications": {
                "title": "Yayınlar",
                "subtitle": "Öğrenme sisteminden başlatmaya açılan senaryolar.",
                "create": "Yeni yayın",
                "edit": "Düzenle",
                "enable": "Aç",
                "disable": "Kapat",
                "open_journal": "Günlük",
                "download_package": "Paketi indir",
                "empty": "Henüz yayın yok.",
                "no_connections": "Henüz bir öğrenme sistemi bağlantısı yok. Bunu platform yöneticisi kurar.",
                "no_expiry": "Süresiz",
                "attempts_unlimited": "Sınırsız",
                "immutable_hint": "Bağlantı, senaryo ve teslim kanalı değiştirilemez: bunlar öğrenme sistemine zaten yüklenmiş pakete gömülüdür. Diğer her şey paket yeniden oluşturulmadan uygulanır.",
                "headers": {
                    "scenario": "Senaryo",
                    "connection": "Bağlantı",
                    "channel": "Kanal",
                    "status": "Durum",
                    "settings": "Ayarlar",
                    "expires_at": "Bitiş",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Deneme: {value}",
                    "threshold": "Geçme eşiği: {value}"
                },
                "status": {
                    "draft": "Taslak",
                    "active": "Aktif",
                    "disabled": "Kapalı"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Yalnızca durum",
                    "status_and_score": "Durum ve puan",
                    "status_score_and_review": "Durum, puan ve incelemeye bağlantı"
                },
                "warnings": {
                    "limited_mode": "Kısıtlı mod: puan ve sonuç öğrenme sisteminde görünmeyecek, atama denetimi yapılmayacak.",
                    "connection_disabled": "Bağlantı kapatıldı: bir yönetici bağlantıyı yeniden açana kadar bu yayın üzerinden başlatmalar hiç kabul edilmiyor.",
                    "assignment_check_off": "Anahtar kapalıyken kurs yeniden atamaları algılanmaz.",
                    "no_course_binding": "Yayın bir kursa bağlı değil — puan öğrenme sistemine ulaşmayacak."
                },
                "dialog": {
                    "connection_label": "Bağlantı",
                    "scenario_label": "Senaryo",
                    "channel_label": "Teslim kanalı",
                    "channel_hint": "Pakete gömülüdür ve sonradan değiştirilemez.",
                    "status_label": "Durum",
                    "status_hint": "Yayın hiçbir zaman silinmez — kapatılır. Bundan sonra yeni başlatmalar reddedilir ve henüz gönderilmemiş sonuçlar iptal edilir.",
                    "settings_section": "Deneme ayarları",
                    "attempts_label": "Öğrenci başına deneme",
                    "attempts_unlimited": "Sınırsız",
                    "daily_budget_label": "Öğrenci başına günlük başlatma",
                    "daily_budget_hint": "Kotayı korur: başlatılan her konuşma kotadan düşer ve geri verilmez.",
                    "result_mode_label": "Öğrenme sistemine giden bilgi",
                    "pass_threshold_label": "Geçme eşiği, 0–100",
                    "result_wait_label": "Değerlendirmeyi bekleme süresi, saat",
                    "result_wait_hint": "Bu sürenin sonunda başlatma “sonuç yok” bildirir.",
                    "launch_limit_label": "Toplam başlatma sınırı",
                    "launch_limit_hint": "Sınır yoksa boş bırakın.",
                    "assignment_check_label": "Öğrenme sisteminde atamayı denetle",
                    "binding_section": "Öğrenme sistemindeki bağ",
                    "external_course_label": "Kurs Kimliği",
                    "external_item_label": "Öğe Kimliği",
                    "expires_label": "Yayının bitiş tarihi",
                    "expires_hint": "Yayının süresi dolmuyorsa boş bırakın."
                },
                "key_dialog": {
                    "title": "Yayın oluşturuldu",
                    "warning": "Anahtar yalnızca bir kez ve yalnızca burada gösterilir. Daha sonra hiçbir yerden okunamaz — şimdi kopyalayın ve paket ayarlarına girin. Kaybederseniz yeni bir yayın oluşturmanız gerekir.",
                    "key_label": "Yayın anahtarı",
                    "copied": "Kopyalandı",
                    "package_hint": "Anahtar zaten paketin içinde, bu yüzden hiçbir yere yapıştırmanıza gerek yok. Paketi indirip öğrenme sistemine yükleyin. Paketi Yayınlar sayfasından istediğiniz zaman yeniden indirebilirsiniz."
                },
                "messages": {
                    "saved": "Yayın kaydedildi",
                    "enabled": "Yayın açıldı",
                    "disabled": "Yayın kapatıldı",
                    "download_failed": "Paket indirilemedi. Sayfayı yenileyip tekrar deneyin."
                }
            },
            "journal": {
                "title": "Başlatma günlüğü",
                "unknown_scenario": "Senaryo kullanılamıyor",
                "back": "Yayınlara dön",
                "revoke": "Denemeyi iptal et",
                "revoke_confirm": "Bu deneme iptal edilsin mi? Öğrenci konuşmaya erişimini kaybeder ve gönderilmemiş teslimler iptal edilir.",
                "retry_delivery": "Yeniden dene",
                "empty_launches": "Henüz başlatma yok.",
                "empty_events": "Henüz olay yok.",
                "no_deliveries": "Bu denemenin teslimi yok.",
                "not_held_quota_charged": "Gerçekleşmedi, kota düşüldü",
                "relaunches": "geri dönüş: {value}",
                "last_launch": "son başlatma: {value}",
                "result_deadline": "Değerlendirme {value} tarihine kadar bekleniyor",
                "learner_contacts": "Öğrenme sisteminin gönderdiği adres: {email}. Başlatıldığı adres: {ip}",
                "score_passed": "{value} — geçti",
                "score_failed": "{value} — geçmedi",
                "tabs": {
                    "launches": "Denemeler",
                    "events": "Olaylar"
                },
                "headers": {
                    "learner": "Öğrenci",
                    "user": "Hesap",
                    "attempt": "Deneme",
                    "status": "Durum",
                    "game": "Konuşma",
                    "started_at": "Başlangıç",
                    "actions": " ",
                    "event_type": "Olay",
                    "refusal": "Neden",
                    "request_proof": "İstek kanıtı",
                    "ip": "Adres",
                    "user_agent": "İstemci",
                    "happened_at": "Ne zaman"
                },
                "launch_status": {
                    "created": "Bağlantı verildi",
                    "started": "Devam ediyor",
                    "not_held": "Gerçekleşmedi",
                    "awaiting_result": "Değerlendirme bekleniyor",
                    "result_ready": "Sonuç teslim edildi",
                    "evaluation_failed": "Değerlendirme yok",
                    "result_timed_out": "Bekleme süresi doldu",
                    "assignment_changed": "Atama değişti",
                    "revoked": "İptal edildi"
                },
                "delivery": {
                    "version": "Sürüm",
                    "status": "Durum",
                    "outcome": "Sonuç",
                    "result": "Başarı durumu",
                    "score": "Puan",
                    "attempts": "Denemeler",
                    "last_attempt": "Son deneme",
                    "external_state": "Öğrenme sistemindeki durum"
                },
                "delivery_status": {
                    "pending": "Kuyrukta",
                    "in_progress": "Gönderiliyor",
                    "done": "Tamamlandı",
                    "needs_attention": "Dikkat gerektiriyor"
                },
                "delivery_outcome": {
                    "accepted": "Kabul edildi",
                    "confirmed": "Onaylandı",
                    "rejected_by_external": "Reddedildi",
                    "retry": "Yeniden deneme planlandı",
                    "cancelled": "İptal edildi",
                    "assignment_changed": "Atama değişti"
                },
                "result": {
                    "passed": "Geçti",
                    "failed": "Geçmedi",
                    "not_held": "Gerçekleşmedi",
                    "no_result": "Sonuç yok"
                },
                "refusal": {
                    "publication_disabled": "Yayın kapalı",
                    "publication_draft": "Yayın taslak",
                    "publication_expired": "Yayının süresi doldu",
                    "feature_disabled": "Dış başlatma kapalı",
                    "connection_disabled": "Bağlantı kapatıldı",
                    "launch_limit_reached": "Başlatma sınırına ulaşıldı",
                    "daily_budget_exhausted": "Günlük bütçe tükendi",
                    "attempts_exhausted": "Denemeler tükendi",
                    "quota_exhausted": "Kuruluş kotası tükendi",
                    "user_limit_reached": "Boş koltuk kalmadı",
                    "scenario_unavailable": "Senaryo kullanılamıyor",
                    "assignment_check_unavailable": "Atama denetimi kullanılamıyor",
                    "code_invalid": "Bağlantı kullanılmış veya süresi dolmuş",
                    "channel_verification_failed": "Öğrenme sistemi isteği doğrulamadı",
                    "external_system_unavailable": "Öğrenme sistemi atama denetimine yanıt vermedi",
                    "user_not_found": "Öğrenci hesabı yok",
                    "user_unavailable": "Öğrenci hesabı devre dışı",
                    "user_deleted": "Öğrenci hesabı silindi",
                    "email_taken_linking_disabled": "Adres başka bir hesaba ait",
                    "service_role_not_allowed": "Hizmet hesabı pratik yapamaz",
                    "unverified_request": "İstek doğrulanmadı"
                },
                "event_type": {
                    "launch_refused": "Başlatma reddedildi",
                    "exchange_refused": "Bağlantı reddedildi",
                    "exchange_succeeded": "Bağlantı kullanıldı"
                },
                "request_proof": {
                    "unverified": "Doğrulanmadı",
                    "assignment_verified": "Atama doğrulandı"
                },
                "messages": {
                    "retry_queued": "Yeniden deneme kuyruğa alındı",
                    "revoked": "Deneme iptal edildi"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Eğitim",
            "interview": "Mülakat"
        },
        "load": {
            "loading": "Oturum yükleniyor…",
            "failed": "Oturum yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
            "scenarioFailed": "Senaryo yüklenemedi",
            "scenarioRetry": "Tekrar dene"
        },
        "leave": {
            "confirm": "Konuşma hâlâ devam ediyor. Sayfadan ayrılmak konuşmayı sonlandırmaz, süre işlemeye devam eder. Sayfadan ayrılınsın mı?",
            "confirmEnd": "Konuşma hâlâ devam ediyor. Ayrılırsanız sona erecek ve ele alabildiğiniz kadarıyla değerlendirilecek. Ayrılınsın mı?"
        },
        "elsewhere": {
            "interviewTitle": "Mülakat başka bir sekmede açık",
            "interviewText": "Mülakat başka bir sekmede veya başka bir cihazda devam ediyor. Oradan devam edin — bu sekmeyi kapatabilirsiniz.",
            "conversationTitle": "Konuşma başka bir sekmede açık",
            "conversationText": "Konuşma başka bir sekmede veya başka bir cihazda devam ediyor. Oradan devam edin — bu sekmeyi kapatabilirsiniz."
        },
        "prep": {
            "header": {
                "backToSessions": "Oturumlara",
                "themeToggleAriaLabel": "Temayı değiştir"
            },
            "scenario": {
                "sectionLabel": "Senaryo",
                "competenceLabel": "Değerlendirilen yetkinlik",
                "gameNumber": "Oturum #{number}",
                "duration": "{minutes} dk",
                "readFull": "Tamamını oku",
                "generalLabel": "Genel bilgiler",
                "playerLabel": "Sizin için bilgiler"
            },
            "selfCamera": {
                "previewLabel": "Kameranızın önizlemesi",
                "off": "Kamera kapalı"
            },
            "notes": {
                "empty": "Boş"
            },
            "start": {
                "button": "Oturumu başlat",
                "interviewButton": "Mülakatı başlat",
                "resumeButton": "Konuşmaya dön",
                "resumeHint": "Konuşma zaten sürüyor — süre işlemeye devam ediyor."
            }
        },
        "equipment": {
            "status": {
                "checking": "Ekipman kontrol ediliyor",
                "waiting": "İzin bekleniyor",
                "denied": "Erişim reddedildi",
                "busy": "Cihaz meşgul",
                "noCamera": "Kamera yok",
                "missing": "Mikrofon yok",
                "dismissed": "İzin verilmedi",
                "ready": "Ekipman hazır"
            },
            "checking": {
                "title": "Mikrofonunuz ve kameranız kontrol ediliyor…"
            },
            "waiting": {
                "title": "Mikrofona erişime izin verin",
                "cameraTitle": "Kameraya erişime izin verin",
                "description": "Tarayıcının izin isteği zaten açık. Mikrofon olmadan konuşma başlayamaz."
            },
            "denied": {
                "title": "Tarayıcı mikrofonu engelliyor",
                "cameraTitle": "Tarayıcı kamerayı engelliyor",
                "description": "Tarayıcınız engellemeyi hatırladı. Site ayarlarından mikrofon erişimine izin verin ve sayfayı yenileyin.",
                "cameraDescription": "Tarayıcınız engellemeyi hatırladı. Site ayarlarından kamera erişimine izin verin ve sayfayı yenileyin.",
                "showInstructions": "Nasıl yapılır göster",
                "hideInstructions": "Gizle",
                "chromeEdge": {
                    "browser": "Chrome ve Edge",
                    "text": "Adres çubuğunun solundaki kilit simgesine tıklayın, «Site ayarları»nı açın, «Mikrofon»a izin verin ve sayfayı yenileyin."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Safari menüsü → «Bu Web Sitesi için Ayarlar»ı açın, «Mikrofon»a izin verin ve sayfayı yenileyin."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Adres çubuğundaki mikrofon simgesine tıklayın, bu site için engeli kaldırın ve sayfayı yenileyin."
                },
                "system": {
                    "title": "Sisteminiz tarayıcının mikrofona erişimini engelliyor",
                    "cameraTitle": "Sisteminiz tarayıcının kameraya erişimini engelliyor",
                    "macos": "macOS: Sistem Ayarları → Gizlilik ve Güvenlik → Mikrofon (veya Kamera) → tarayıcınızı açın, ardından yeniden başlatın.",
                    "windows": "Windows: Ayarlar → Gizlilik ve güvenlik → Mikrofon (veya Kamera) → uygulamalara ve tarayıcınıza erişim izni verin, sonra «Tekrar dene»ye basın."
                }
            },
            "busy": {
                "title": "Mikrofon başka bir uygulama tarafından kullanılıyor",
                "cameraTitle": "Kamera başka bir uygulama tarafından kullanılıyor",
                "description": "Genellikle bu, arka planda açık kalmış bir görüşmedir. Onu kapatıp «Tekrar dene»ye tıklayın.",
                "retry": "Tekrar dene"
            },
            "noCamera": {
                "title": "Kamera yok",
                "description": "Sesiniz duyulur ama görüntünüz görünmez.",
                "requiredByScenario": "Bu konuşma bir kamera gerektiriyor. Devam etmek için bir kamera bağlayın."
            },
            "missing": {
                "title": "Mikrofon bulunamadı",
                "description": "Bir mikrofon bağlayıp «Tekrar dene»ye basın. Mikrofon olmadan konuşma başlayamaz."
            },
            "dismissed": {
                "title": "Mikrofon erişimine izin verilmedi",
                "cameraTitle": "Kamera erişimine izin verilmedi",
                "description": "Tarayıcı penceresi yanıt verilmeden kapatıldı. «Tekrar dene»ye basıp erişime izin verin."
            },
            "ready": {
                "title": "Ekipman hazır"
            },
            "micLabel": "Mikrofon",
            "cameraLabel": "Kamera",
            "chooseMic": "Mikrofon seçin",
            "chooseCamera": "Kamera seçin",
            "micLevelHint": "Bir şey söyleyin",
            "speakerValue": "Hoparlör: {name}",
            "configure": "Yapılandır",
            "dialog": {
                "title": "Ekipman",
                "lockedDuringConversation": "Cihazlar konuşma sırasında değiştirilemez.",
                "micSelectLabel": "Mikrofon",
                "cameraSelectLabel": "Kamera",
                "speakerSelectLabel": "Hoparlör",
                "noCameraOption": "Kamerasız",
                "record": "3 saniye kaydet",
                "recording": "Kaydediliyor…",
                "recordFailed": "Kaydedilemedi. Tekrar deneyin.",
                "listen": "Dinle",
                "playing": "Oynatılıyor…",
                "done": "Tamam",
                "closeAriaLabel": "İletişim kutusunu kapat"
            },
            "unnamed": {
                "microphone": "Mikrofon {number}",
                "camera": "Kamera {number}",
                "speaker": "Hoparlör {number}"
            },
            "cameraWarmup": {
                "preview": "Kamera açılıyor",
                "title": "Mikrofon hazır",
                "description": "Kamera yetişecek — genellikle bir iki saniye içinde.",
                "slowHint": "Kamera açılmıyor mu? «Yapılandır» ile başka bir kamera seçin."
            }
        },
        "recording": {
            "videoAndAudio": "Konuşma ve görüntü kaydediliyor.",
            "audioOnly": "Konuşma kaydediliyor.",
            "accessSelfAndEvaluators": "Kayıt, sizin ve çalışmanızı değerlendirenlerin erişimine açıktır.",
            "accessEvaluators": "Kayıt, çalışmanızı değerlendirenlerin erişimine açıktır."
        },
        "scenario": {
            "video": "Senaryo yazarından video"
        },
        "notes": {
            "title": "Oturum notları",
            "placeholder": "Neyi çalışmak istediğiniz, hazırladığınız ifadeler",
            "saving": "Kaydediliyor…",
            "saved": "Kaydedildi",
            "saveError": "Kaydedilemedi",
            "visibility": "Notlar size ve oturumu değerlendirenlere görünür.",
            "unsupported": "Bu notlar burada düzenlenemeyen öğeler içeriyor. Değiştirilmeden saklanır."
        },
        "stage": {
            "agentState": {
                "speaking": "Konuşuyor",
                "listening": "Dinliyor",
                "thinking": "Düşünüyor"
            },
            "micOffWarning": "Mikrofon kapalı — karşı taraf sizi duyamıyor",
            "micOnAriaLabel": "Mikrofonu kapat",
            "micOffAriaLabel": "Mikrofonu aç",
            "micOff": "Mikrofon kapalı",
            "micOnAnnouncement": "Mikrofon açık",
            "captionsLabel": "Altyazı",
            "captionsOnAriaLabel": "Altyazıyı gizle",
            "captionsOffAriaLabel": "Altyazıyı göster",
            "talkBalance": {
                "title": "Konuşma dengesi",
                "you": "Siz",
                "interlocutor": "Muhatap"
            },
            "connectionQuality": {
                "excellent": "Mükemmel bağlantı",
                "good": "İyi bağlantı",
                "poor": "Zayıf bağlantı",
                "unknown": "Bağlantı kalitesi bilinmiyor"
            },
            "selfCameraLabel": "Siz",
            "timeWarning": {
                "lastMinute": "Bir dakika kaldı — toparlama zamanı",
                "finalSeconds": "15 saniye — düşüncenizi tamamlayın"
            },
            "timeUp": {
                "title": "Süre doldu",
                "text": "Konuşma kendiliğinden kapanacak; uzatılamaz.",
                "closing": "Konuşma kapatılıyor…"
            },
            "voiceOnly": "Yalnızca ses modu — bu senaryoda video yok",
            "interlocutorConnecting": {
                "title": "Muhatap bağlanıyor",
                "hint": "Genellikle 2–4 saniye"
            },
            "layout": {
                "label": "Yan yana",
                "sideTitle": "Yan yana yerleştir",
                "focusTitle": "Muhatabı büyüt"
            }
        },
        "panels": {
            "scenario": "Senaryo",
            "transcript": "Döküm",
            "transcriptEmpty": "Tamamlanan yanıtlar burada görünecek.",
            "notes": "Notlar",
            "characterMemoryTab": "Karakterin hatırladıkları",
            "openAriaLabel": "«{panel}» panelini aç",
            "closeAriaLabel": "«{panel}» panelini kapat"
        },
        "sound": {
            "label": "Ses",
            "volumeLabel": "Ses düzeyi",
            "speakerLabel": "Hoparlör"
        },
        "end": {
            "button": "Bitir",
            "confirmTitle": "Konuşma sona erdirilsin mi?",
            "elapsed": "{total} içinden {elapsed} geçti.",
            "partialEvaluationNotice": "Konuşma, ele alabildiğiniz kadarıyla değerlendirilecek.",
            "continue": "Devam et",
            "notSent": "Konuşma süre dolunca sona erecek: sunucu sonlandırma isteğine yanıt vermedi."
        },
        "wait": {
            "title": "Konuşmayı hazırlıyoruz",
            "hint": "Bu genellikle 1–3 dakika sürer. Sayfayı kapatmayın — otomatik olarak başlayacağız.",
            "nextTry": "Sonraki deneme: {time} sonra",
            "trying": "Başlatmayı deniyoruz…",
            "retrying": "Henüz olmadı. {time} sonra tekrar deneyeceğiz",
            "cancel": "İptal",
            "failed": {
                "title": "Konuşma başlatılamadı",
                "text": "Şu anda boş yer yok. Mikrofon ve kamera ayarlarınız kaydedildi — birkaç dakika sonra tekrar deneyin.",
                "retry": "Tekrar dene"
            }
        },
        "connection": {
            "reconnecting": "Bağlantı kesildi, yeniden bağlanıyor…",
            "restored": "Bağlantı geri geldi",
            "failed": "Bağlantı geri yüklenemedi",
            "retry": "Tekrar dene"
        },
        "hotkeys": {
            "title": "Klavye kısayolları",
            "showHintAriaLabel": "Klavye kısayollarını göster",
            "micToggle": "Mikrofonu aç/kapat",
            "scenarioPanel": "Senaryo: paneli aç ve kapat",
            "transcriptPanel": "Döküm",
            "notesPanel": "Notlar",
            "captionsToggle": "Altyazıyı aç/kapat",
            "closeTopLayer": "Paneli, popover'ı veya iletişim kutusunu kapat",
            "endConfirm": "Bitir — onayı açar",
            "showHint": "Bu ipucunu göster"
        },
        "intro": {
            "candidate": {
                "greeting": "Merhaba, {name}!",
                "leadWithVacancy": "{organization} sizi «{vacancy}» pozisyonu için sanal bir muhatapla yapılacak mülakata davet ediyor.",
                "duration": "Mülakat yaklaşık {minutes} dakika sürecek.",
                "requirementsTitle": "Nelere ihtiyacınız olacak",
                "requirementMic": "Çalışan bir mikrofon, tercihen mikrofonlu kulaklık",
                "requirementCameraRequired": "Açık bir kamera: bu mülakat için zorunludur",
                "requirementCameraOptional": "Kamera zorunlu değildir, ancak görüşme onunla daha doğal geçer",
                "requirementBrowser": "Bilgisayar ve güncel bir Chrome, Edge veya Safari tarayıcısı",
                "requirementNetwork": "Kararlı bir internet bağlantısı ve kimsenin sizi rahatsız etmeyeceği sessiz bir ortam",
                "consentTextLabel": "Onay metni",
                "consentAccept": "Metni okudum ve kişisel verilerimin işlenmesine onay veriyorum",
                "next": "İleri"
            },
            "launch": {
                "title": "Pratik konuşması",
                "lead": "Az sonra sanal bir muhatapla konuşacaksınız. Konuşma kaydedilir ve değerlendirilir, sonuç öğrenme sisteminize geri döner.",
                "requirementsTitle": "İhtiyacınız olanlar",
                "requirementMic": "Çalışan bir mikrofon, tercihen kulaklık",
                "requirementCamera": "Kamera zorunlu değildir, ancak konuşma onunla daha doğal geçer",
                "requirementBrowser": "Güncel Chrome, Edge veya Safari yüklü bir bilgisayar",
                "requirementNetwork": "Kararlı bir bağlantı ve sizi kimsenin bölmeyeceği sessiz bir ortam",
                "start": "Başlat"
            }
        },
        "finished": {
            "candidate": {
                "title": "Teşekkürler!",
                "text": "Mülakat tamamlandı. Sonuç işe alım uzmanına iletilecek — sizinle iletişime geçecektir. Bu sayfayı şimdi kapatabilirsiniz."
            },
            "launch": {
                "title": "Teşekkürler!",
                "text": "Konuşma sona erdi. Sonuç değerlendirildikten sonra öğrenme sisteminizde görünecek. Bu sayfayı şimdi kapatabilirsiniz."
            }
        },
        "closeDialogAriaLabel": "İletişim kutusunu kapat"
    },
    "loopAvatars": {
        "title": "Döngülü avatarlar",
        "upload": "Avatar yükle",
        "newVersion": "Yeni sürüm",
        "newVersionHint": "“{name}”, mevcut sürüm {version}. Yeni paket, bu avatarın kullanıldığı tüm profillerdeki videoların yerini alır.",
        "edit": "Avatarı düzenle",
        "delete": "Avatarı sil",
        "empty": "Henüz avatar yok",
        "headers": {
            "poster": "Poster",
            "name": "Ad",
            "gender": "Cinsiyet",
            "emotion": "Duygu",
            "visibility": "Görünürlük",
            "version": "Sürüm",
            "profiles": "Profiller"
        },
        "gender": {
            "male": "Erkek",
            "female": "Kadın"
        },
        "emotion": {
            "calm": "Sakin",
            "friendly": "Samimi",
            "strict": "Sert"
        },
        "visibility": {
            "all": "Tüm organizasyonlar"
        },
        "fields": {
            "package": "Avatar paketi (.zip)"
        },
        "packageHint": "En fazla 100 MB ZIP: manifest.json, listen.mp4, talk.mp4, transitions.json ve poster.jpg",
        "validation": {
            "packageTooLarge": "Paket 100 MB'ı aşmamalıdır"
        },
        "errors": {
            "requestFailed": "İstek tamamlanamadı. Lütfen tekrar deneyin."
        },
        "confirmDetach": "Bağlantısı kaldırılacak profil sayısı: {count}. Fotoğrafa geçecekler. Kaydedilsin mi?",
        "confirmDelete": "“{name}” avatarı silinsin mi?",
        "confirmDeleteWithProfiles": "“{name}” avatarı şu kadar profilde kullanılıyor: {count}. Fotoğrafa geçecekler. Silinsin mi?"
    },
    "ttsVoices": {
        "title": "TTS sesleri",
        "create": "Ses ekle",
        "edit": "Sesi düzenle",
        "delete": "Sesi sil",
        "replaceSample": "Örneği değiştir",
        "replaceSampleHint": "“{name}”, mevcut örnek sürümü {version}. Yeni örnek, bu sesin kullanıldığı tüm profillerde çalınır.",
        "empty": "Henüz ses yok",
        "play": "Örneği dinle",
        "stop": "Durdur",
        "headers": {
            "name": "Ad",
            "provider": "Sağlayıcı",
            "externalId": "Ses kimliği",
            "gender": "Cinsiyet",
            "languages": "Diller",
            "visibility": "Görünürlük",
            "sample": "Örnek",
            "profiles": "Profiller"
        },
        "gender": {
            "male": "Erkek",
            "female": "Kadın"
        },
        "visibility": {
            "all": "Tüm organizasyonlar"
        },
        "fields": {
            "sample": "Ses örneği",
            "speed": "Konuşma hızı"
        },
        "sampleHint": "En fazla 5 MB MP3, MP4 veya M4A",
        "sampleOptionalHint": "İsteğe bağlı — örnek, ses kimliği kullanılarak bu sesle oluşturulur. En fazla 5 MB MP3, MP4 veya M4A",
        "synthesizeSample": "Yeniden oluştur",
        "speedChangedHint": "Yeni hızı duymak için ses örneğini yeniden oluşturun.",
        "speedSamplePromptTitle": "Hız değiştirildi",
        "speedSamplePrompt": "Örnek hâlâ önceki hızda çalıyor. Yeniden oluşturulsun mu? Mevcut örnek değiştirilecek.",
        "saveAndSynthesize": "Kaydet ve oluştur",
        "saveOnly": "Yalnızca kaydet",
        "validation": {
            "sampleTooLarge": "Örnek 5 MB'ı aşmamalıdır"
        },
        "errors": {
            "requestFailed": "İstek tamamlanamadı. Lütfen tekrar deneyin.",
            "sampleUnavailable": "Örnek oynatılamadı"
        },
        "confirmDetach": "Bağlantısı kaldırılacak profil sayısı: {count}. Bağlayıcı sesine geçecekler. Kaydedilsin mi?",
        "confirmDelete": "“{name}” sesi silinsin mi?",
        "confirmDeleteWithProfiles": "“{name}” sesi şu kadar profilde kullanılıyor: {count}. Bağlayıcı sesine geçecekler. Silinsin mi?",
        "picker": {
            "none": "Varsayılan ses",
            "empty": "Katalogda bu cinsiyete ait ses yok",
            "loadError": "Sesler yüklenemedi",
            "playSample": "Örneği dinle: {name}",
            "stopSample": "Örneği durdur: {name}",
            "sampleUnavailable": "Örnek kullanılamıyor"
        }
    },
    "realtimeAvatars": {
        "title": "Live avatarlar",
        "create": "Avatar ekle",
        "edit": "Avatarı düzenle",
        "delete": "Avatarı sil",
        "preview": "Önizlemeyi izle",
        "empty": "Henüz avatar yok",
        "headers": {
            "poster": "Poster",
            "name": "Ad",
            "provider": "Sağlayıcı",
            "externalId": "Avatar kimliği",
            "gender": "Cinsiyet",
            "visibility": "Görünürlük",
            "profiles": "Profiller",
            "models": "Anam modelleri"
        },
        "gender": {
            "male": "Erkek",
            "female": "Kadın"
        },
        "visibility": {
            "all": "Tüm kuruluşlar"
        },
        "nameHint": "İsteğe bağlı — Anam'daki ad kullanılır",
        "externalIdHint": "Kimliği değiştirirseniz poster ve önizleme Anam'dan yeniden yüklenir",
        "errors": {
            "requestFailed": "İstek tamamlanamadı. Lütfen tekrar deneyin.",
            "previewUnavailable": "Önizleme oynatılamadı"
        },
        "confirmDetach": "Bağlantısı kaldırılacak profil sayısı: {count}. Bu profiller fotoğrafa geçecek. Kaydedilsin mi?",
        "confirmDelete": "“{name}” avatarı silinsin mi?",
        "confirmDeleteWithProfiles": "“{name}” avatarı şu kadar profilde kullanılıyor: {count}. Bu profiller fotoğrafa geçecek. Silinsin mi?",
        "picker": {
            "label": "Live avatarlar",
            "empty": "Bu profil için uygun Live avatar yok",
            "emptyFiltered": "Bu cinsiyette Live avatar yok",
            "loadError": "Live avatarlar yüklenemedi"
        }
    },
    "aiProfileAppearance": {
        "label": "Görünüm",
        "photo": "Özel fotoğraf",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Maskot",
        "filterGender": "Cinsiyet",
        "filterEmotion": "Duygu",
        "avatarsLabel": "Avatarlar",
        "avatarRequired": "Bir avatar seçin",
        "liveRequired": "Bir Live avatar seçin",
        "livePlaceholder": "Live avatarınız burada görünecek",
        "empty": "Bu profil için uygun avatar yok",
        "emptyFiltered": "Hiçbir avatar filtrelerle eşleşmiyor",
        "loadError": "Avatarlar yüklenemedi",
        "playPreview": "Önizlemeyi oynat: {name}",
        "pausePreview": "Önizlemeyi duraklat: {name}"
    },
    "emailStopList": {
        "title": "E-posta engel listesi",
        "description": "Bu adreslere ve alan adlarına e-posta gönderilmez. Bir alan adı kaydı, o alan adının tüm adreslerini kapsar, ancak alt alan adlarını kapsamaz.",
        "searchPlaceholder": "Adrese veya alan adına göre ara",
        "allReasons": "Tüm nedenler",
        "add": "Ekle",
        "addTitle": "Bir adresi veya alan adını engelle",
        "empty": "Engel listesi boş",
        "editNote": "Notu düzenle",
        "headers": {
            "type": "Tür",
            "value": "Adres veya alan adı",
            "reason": "Neden",
            "providerReply": "E-posta hizmetinin yanıtı",
            "note": "Not",
            "author": "Ekleyen",
            "createdAt": "Eklenme tarihi",
            "blockedCount": "Durdurulan e-postalar",
            "lastBlockedAt": "Son durdurma"
        },
        "type": {
            "address": "Adres",
            "domain": "Alan adı"
        },
        "reason": {
            "manual": "Elle eklendi",
            "providerRejected": "E-posta hizmeti tarafından reddedildi"
        },
        "author": {
            "system": "Sistem"
        },
        "fields": {
            "value": "Adres veya alan adı",
            "valueHint": "Adresin tamamını veya yalnızca alan adını girin. Alan adı, kendi tüm adreslerini engeller, ancak alt alan adlarını engellemez.",
            "note": "Not"
        },
        "errors": {
            "requestFailed": "Bir sorun oluştu. Lütfen tekrar deneyin."
        },
        "unblock": {
            "action": "Engeli kaldır",
            "confirm": "{value} engeli kaldırılsın mı?",
            "resultTitle": "Engel kaldırma sonucu",
            "result": {
                "removedEverywhere": "Engel kaldırıldı. E-posta hizmetinin engel listesinde bu adres yok, bu nedenle e-postalar yeniden gönderilecek.",
                "removedLocally": "Alan adının engeli kaldırıldı. Bu alan adına ait olup kendi kaydı bulunan adresler engelli kalır.",
                "providerNotConfigured": "Yalnızca platform kaydı kaldırıldı: e-posta hizmetiyle bağlantı kurulmamış olduğundan hizmetin engel listesi kontrol edilmedi.",
                "providerUnavailable": "E-posta hizmeti kullanılamıyor, daha sonra tekrar deneyin. Adres hâlâ engelli.",
                "stillListedAtProvider": "Adres e-posta hizmetinin engel listesinde. Hizmetin panelinden kaldırın, ardından “Engeli yeniden kaldır” düğmesine tıklayın. Panelde adres görünmüyorsa, hizmetin genel engel listesindedir ve oradan kaldırılamaz."
            },
            "openPanel": "E-posta hizmeti panelini aç",
            "panelPath": "Nereden kaldırılır: e-posta hizmeti paneli → Products → Email Service → kaynağınız → Stop Lists sekmesi.",
            "retry": "Engeli yeniden kaldır"
        },
        "suggestions": {
            "text": "{domain} alan adında {count} engelli adres var. Alan adının tamamı engellensin mi?",
            "block": "Alan adını engelle",
            "confirm": "{domain} alan adı engellensin mi? Tüm adreslerine e-posta gönderilmesi durdurulacak. Alt alan adları etkilenmez, tek tek adreslerin kayıtları kalır."
        },
        "check": {
            "title": "Adresi kontrol et",
            "hint": "Adrese gönderilen e-postaların platform veya e-posta hizmeti tarafından engellenip engellenmediğini gösterir",
            "placeholder": "E-posta adresi",
            "submit": "Kontrol et",
            "resultFor": "{email} için sonuç",
            "platform": "Platform engel listesi",
            "platformListed": "Evet — “{value}” kaydı",
            "provider": "E-posta hizmetinin engel listesi",
            "listed": "Evet",
            "notListed": "Hayır",
            "providerReasons": "E-posta hizmetinin bildirdiği nedenler:",
            "providerNotConfigured": "E-posta hizmetiyle bağlantı kurulmamış",
            "providerUnavailable": "E-posta hizmeti kullanılamıyor, daha sonra tekrar deneyin"
        }
    }
}
